//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AcceptInviteEmailTemplate {
    options?: AcceptInviteEmailTemplateOptions;
    readonly design?: string | undefined;
    readonly html?: string | undefined;
}

export interface AcceptInviteEmailTemplateOptions {
    subject?: string | undefined;
}

export interface AcceptPartyInviteRequest {
    inviteId?: string;
    inviteCode: string | undefined;
}

export interface AcceptPartyInviteResponse {
    buyerPartyId?: string;
}

export interface ActivityDto {
    externalCode: string | undefined;
    externalSequenceNumber: string | undefined;
    description: string | undefined;
    workingStepType: WorkingStepType;
    ratePerDuration: MoneyPerQuantityDto;
    materialTokens: { [key: string]: KeywordDto[]; } | undefined;
    purchasingLength: QuantityDto;
    purchasingWidth: QuantityDto;
    purchasingHeight: QuantityDto;
    purchasingDimensions: PurchasingDimensions;
    canUploadResourceSpec: boolean;
    hasSpecification: boolean;
    isSelectable: boolean;
    costsCanBeShared: boolean;
    shareRatioBy: ShareRatioBy;
    batchIndependent: boolean;
    supportsMaterialEstimator: boolean;
    hasMaterialEstimator: boolean;
    usesRawMaterial: boolean;
    type: ResourceActivityTypeDto;
    supportedTypes: ResourceActivityTypeDto[] | undefined;
    materialEstimatorType: MaterialEstimatorTypeDto;
    supportedMaterialEstimatorTypes: MaterialEstimatorTypeDto[] | undefined;
}

export interface AddActivityArgs {
    id?: string | undefined;
    name?: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface AddAgentArgs {
    name?: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface AddAgentIntegrationArgs {
    integrationType?: IntegrationType;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface AddDeliveryTermsRequest {
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface AddDeliveryTermsResponse {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface AddKeywordsToPartsArgs {
    rowIds: string[];
    keywords: string[];
}

export interface AddPartyCanBuyFromRequest {
    buyingPartyId?: string;
    sellingPartyId?: string;
}

export interface AddPartyRequest {
    id: string | undefined;
    name: string | undefined;
    coCKey: string | undefined;
    currencyCode: string | undefined;
    hasSubscription: boolean;
    hasSelfServicePortal: boolean;
    hasSupportChat: boolean;
    hasSelfServicePortalSupportChat: boolean;
    modules: AppModule[] | undefined;
}

export interface AddPartyUserRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    role: string | undefined;
    portalThemeCustomization?: PortalThemeCustomization;
}

export interface AddPaymentTermsRequest {
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface AddPaymentTermsResponse {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface AddRegressionTestsArgs {
    rowIds?: string[] | undefined;
}

export interface AddServicesApiUserRequest {
    partyId: string;
    userId: string | undefined;
}

export interface AddSupplierActivitiesRequest {
    supplierActivities: AddSupplierActivity[] | undefined;
}

export interface AddSupplierActivity {
    supplierId: string;
    workingStepType: WorkingStepType;
}

export interface AddUserRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export interface AdditionalWorkingStepDto {
    jsonSchema: string | undefined;
    uiSchema: string | undefined;
    formData?: any | undefined;
}

export interface AddressBookDto {
    id: string;
    code: string | undefined;
    companyName: string | undefined;
    postalStreet?: string | undefined;
    postalHouseNumber?: string | undefined;
    postalHouseNumberAddition?: string | undefined;
    postalZipCode?: string | undefined;
    postalCity?: string | undefined;
    postalStateOrProvince?: string | undefined;
    postalCountryCode?: string | undefined;
    postalCountryName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    bicOrSwiftCode?: string | undefined;
    iban?: string | undefined;
    vatNumber?: string | undefined;
    vatRatio: QuantityDto;
    coCNumber?: string | undefined;
    coCBranchNumber?: string | undefined;
    coCCountryCode?: string | undefined;
    coCCountryName?: string | undefined;
    showInviteButton?: boolean;
    showReSendInviteButton?: boolean;
    showRevokeInviteButton?: boolean;
    showRevokeAccessButton?: boolean;
    hasPortalAccess?: boolean;
    languageCode?: string | undefined;
    languageDescription?: string | undefined;
    invitation?: InvitationDto;
    segment?: string | undefined;
    tags?: string[] | undefined;
    currencyCode: string | undefined;
    provideRawMaterial: ProvideRawMaterialSettingDto;
    deliveryTermsCode: string | undefined;
    paymentTermsCode: string | undefined;
    glnNumber: string | undefined;
}

export interface AddressBookImportErrorDto {
    rowNumber: number;
    errors: string[] | undefined;
}

export interface AddressBookImportJobDto {
    id?: string;
    startTime?: Date;
    finishedTime?: Date | undefined;
    status?: AddressBookImportJobDtoStatus;
    total?: number;
    inserted?: number;
    updated?: number;
    skipped?: number;
    deleted?: number;
    errors: AddressBookImportErrorDto[] | undefined;
}

export enum AddressBookImportJobDtoStatus {
    Running = "Running",
    Succeed = "Succeed",
    ContainsErrors = "ContainsErrors",
}

export interface AddressBookRelationDto {
    partyId?: string;
    id: string;
    code: string | undefined;
    companyName: string | undefined;
    postalStreet?: string | undefined;
    postalHouseNumber?: string | undefined;
    postalHouseNumberAddition?: string | undefined;
    postalZipCode?: string | undefined;
    postalCity?: string | undefined;
    postalStateOrProvince?: string | undefined;
    postalCountryCode?: string | undefined;
    postalCountryName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    bicOrSwiftCode?: string | undefined;
    iban?: string | undefined;
    vatNumber?: string | undefined;
    vatRatio: QuantityDto;
    coCNumber?: string | undefined;
    coCBranchNumber?: string | undefined;
    coCCountryCode?: string | undefined;
    coCCountryName?: string | undefined;
    showInviteButton?: boolean;
    showReSendInviteButton?: boolean;
    showRevokeInviteButton?: boolean;
    showRevokeAccessButton?: boolean;
    hasPortalAccess?: boolean;
    languageCode?: string | undefined;
    languageDescription?: string | undefined;
    invitation?: InvitationDto;
    segment?: string | undefined;
    tags?: string[] | undefined;
    currencyCode: string | undefined;
    provideRawMaterial: ProvideRawMaterialSettingDto;
    deliveryTermsCode: string | undefined;
    paymentTermsCode: string | undefined;
    glnNumber: string | undefined;
}

export interface AddressDto {
    street?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberAddition?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    stateOrProvince?: string | undefined;
    country?: CountryDto;
    readonly addressAsString?: string | undefined;
}

export interface AgentConnectedDto {
    isConnected: boolean;
}

export interface AgentDto {
    id: string;
    name: string | undefined;
    isDefault: boolean;
    rootDirectory: string | undefined;
    keepAliveInterval: QuantityDto;
    projectStatusExportStates: ProjectStates[] | undefined;
    projectExportStates: ProjectStates[] | undefined;
    availableProjectStates: ProjectStates[] | undefined;
    agentBuildVersion: string | undefined;
}

export interface AgentIntegrationDto {
    id: string | undefined;
    name: string | undefined;
    integrationType: IntegrationType;
    supportsExportStatus?: boolean;
    exportStates: ProjectStates[] | undefined;
    integrationBuildVersion: string | undefined;
    formData?: any | undefined;
    jsonSchemaObjects?: JsonSchemaObjects;
}

export enum AggregateLevel {
    NotInitialized = "NotInitialized",
    Project = "Project",
    Assembly = "Assembly",
    PartType = "PartType",
    CalculatedValues = "CalculatedValues",
    NestingResults = "NestingResults",
    Party = "Party",
    WorkflowEngine = "WorkflowEngine",
    TestSuite = "TestSuite",
    System = "System",
    Agent = "Agent",
}

export interface AnalyzedArticleDto {
    externalDescription: string | undefined;
    internalDescription: string | undefined;
    code: string | undefined;
    analysis: string[] | undefined;
    keywords: { [key: string]: KeywordDto[]; } | undefined;
    dimensions: DimensionsDto[] | undefined;
    hideInPortal: boolean;
    isDimensionless: boolean;
    tags: string[] | undefined;
    validationErrors: ArticleValidationErrorDto[] | undefined;
    readonly isValid?: boolean;
    weightPerItem: QuantityDto;
}

export enum AnimalScale {
    Unknown = "Unknown",
    Ant = "Ant",
    Mouse = "Mouse",
    Dog = "Dog",
    Cow = "Cow",
    Elephant = "Elephant",
    Whale = "Whale",
}

export interface AnonymousResetPasswordRequest {
    emailAddress: string | undefined;
    portalThemeCustomization: PortalThemeCustomization;
}

export interface ApiMetadata {
    page?: number;
    pageSize?: number;
    totalRecords?: number;
    totalPages?: number;
}

export enum AppModule {
    NotInitialized = "NotInitialized",
    BoMManager = "BoMManager",
    Enterprise = "Enterprise",
    SurfaceTreatment = "SurfaceTreatment",
}

export interface ApplyPriceRequestRequest {
    outgoingPriceRequestId?: string;
    outgoingPriceRequestActivityId?: string;
}

export interface ApplyPriceRequestResponse {
}

export enum AreaUnit {
    Undefined = "Undefined",
    Acre = "Acre",
    Hectare = "Hectare",
    SquareCentimeter = "SquareCentimeter",
    SquareDecimeter = "SquareDecimeter",
    SquareFoot = "SquareFoot",
    SquareInch = "SquareInch",
    SquareKilometer = "SquareKilometer",
    SquareMeter = "SquareMeter",
    SquareMicrometer = "SquareMicrometer",
    SquareMile = "SquareMile",
    SquareMillimeter = "SquareMillimeter",
    SquareNauticalMile = "SquareNauticalMile",
    SquareYard = "SquareYard",
    UsSurveySquareFoot = "UsSurveySquareFoot",
}

export interface ArticleCostPriceArgs {
    articleId: string;
    costPrice: MoneyPerQuantityDto;
    priceScope: PriceScope;
}

export interface ArticleDataFinancialDto {
    id?: string;
    totalProjectQuantity?: number;
    costPricePerItem?: MoneyDto;
    costPriceOfItems?: MoneyDto;
    salesPricePerItem?: MoneyDto;
    salesPriceOfItems?: MoneyDto;
    discountRatio?: QuantityDto;
    discountValuePerItem?: MoneyDto;
    discountValueOfItems?: MoneyDto;
    surchargeRatio?: QuantityDto;
    surchargeValuePerItem?: MoneyDto;
    surchargeValueOfItems?: MoneyDto;
}

export interface ArticleFinancialDto {
    explanation?: string | undefined;
    totalPieces?: number;
    totalQuantity?: QuantityDto;
    costPricePerItem?: MoneyDto;
    costPriceOfItems?: MoneyDto;
    usedRatioPerPiece?: QuantityDto;
    totalWeight?: QuantityDto;
    discountRatio?: QuantityDto;
    surchargeRatio?: QuantityDto;
    salesPricePerItem?: MoneyDto;
    salesPriceOfItems?: MoneyDto;
    discountValuePerItem?: MoneyDto;
    discountValueOfItems?: MoneyDto;
    surchargeValuePerItem?: MoneyDto;
    surchargeValueOfItems?: MoneyDto;
}

export interface ArticleImportErrorDto {
    rowNumber?: number;
    errors: string[] | undefined;
}

export interface ArticleImportJobDto {
    id?: string;
    startTime?: Date;
    finishedTime?: Date | undefined;
    status?: ArticleImportJobDtoStatus;
    total?: number;
    inserted?: number;
    updated?: number;
    skipped?: number;
    deleted?: number;
    errors: ArticleImportErrorDto[] | undefined;
}

export enum ArticleImportJobDtoStatus {
    Running = "Running",
    Succeed = "Succeed",
    ContainsErrors = "ContainsErrors",
}

export interface ArticleManualDiscountArgs {
    discountRatio?: QuantityDto;
    discountValue?: MoneyDto;
    articleId: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ArticleManualSurchargeArgs {
    surchargeRatio?: QuantityDto;
    surchargeValue?: MoneyDto;
    articleId: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ArticleValidationErrorDto {
    message?: string | undefined;
}

export interface AssemblyDto {
    id?: string;
    rowNumber: number;
    partTypeIds?: string[] | undefined;
    representsIndividualParts?: boolean;
    name?: string | undefined;
    thumbnail3d?: string | undefined;
    threeDModelPath?: string | undefined;
    financial?: FinancialDto;
    attachments?: BoMItemAttachmentDto[] | undefined;
    partTypeActivities?: BoMItemActivityDto[] | undefined;
    assemblyActivities?: BoMItemActivityDto[] | undefined;
    originalFileName?: string | undefined;
    isManufacturable?: boolean;
    manufacturableStatus?: string | undefined;
    manufacturableResult?: string | undefined;
    isExportedToErp?: boolean;
    exportedToErpStatus?: string | undefined;
    exportedToErpResult?: string | undefined;
    externalUrl?: string | undefined;
    comment?: string | undefined;
    analysisStatus?: string | undefined;
    analysisErrorMessage?: string | undefined;
    canBeEdit?: boolean;
    precisions?: PrecisionsDto;
    showPrecisions?: boolean;
    drawingNumber?: string | undefined;
    revision?: string | undefined;
    dimensionsSummary?: DimensionSummaryDto;
    issues?: IssueDto[] | undefined;
    lengthUnitAbbreviation?: string | undefined;
    buyingPartyArticleNumber?: string | undefined;
    sellingPartyArticleNumber?: string | undefined;
    animalScale?: AnimalScale;
    engineeringDrawingThumbnail?: string | undefined;
}

export interface AssemblyHeaderDto {
    assembly?: AssemblyDto;
}

export interface AssemblySimplifyDto {
    assemblyId?: string;
    partIds?: string[] | undefined;
}

export interface AssemblyStructureDto {
    id: string;
    rowNumber: number;
    assemblyTypeId: string;
    parentId: string | undefined;
    assembly: AssemblyDto;
    partTypeRows: RowDto[] | undefined;
    workingStepDtos: WorkingStepDto[] | undefined;
    subAssemblies: AssemblyStructureDto[] | undefined;
    originalFileName: string | undefined;
    buyingPartyArticleNumber?: string | undefined;
    sellingPartyArticleNumber?: string | undefined;
}

export interface AssignPartyRoleRequest {
    userId: string | undefined;
    role: string | undefined;
    partyId: string;
}

export interface AssignSystemRoleRequest {
    userId: string | undefined;
    role: string | undefined;
}

export interface AttachmentDto {
    fileName: string | undefined;
    originalFileName: string | undefined;
}

export interface AuthUserDto {
    id: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    emailVerified: boolean | undefined;
    picture: string | undefined;
}

export interface AutoInviteImportErrorDto {
    rowNumber?: number;
    errors?: string[] | undefined;
}

export interface AutoInviteImportJobDto {
    id?: string;
    fileName?: string | undefined;
    startTime?: Date;
    finishedTime?: Date | undefined;
    total?: number;
    inserted?: number;
    updated?: number;
    skipped?: number;
    deleted?: number;
    errors?: AutoInviteImportErrorDto[] | undefined;
    status?: AutoInviteJobStatusDto;
}

export enum AutoInviteJobStatusDto {
    New = "New",
    Running = "Running",
    Succeed = "Succeed",
    ContainsErrors = "ContainsErrors",
}

export interface AvailableWorkspace {
    id: string;
    name: string | undefined;
    domain: string | undefined;
    allowsAutoDomainJoin: boolean;
}

export interface BatchUpdateBoMItemsRequest {
    bomItemUpdates: BoMItemUpdateRequestDto[] | undefined;
}

export interface BoMDto {
    assemblyHeaders?: AssemblyHeaderDto[] | undefined;
    materialHeaders?: MaterialHeaderDto[] | undefined;
    assemblyStructures?: AssemblyStructureDto[] | undefined;
    partTypeRows?: RowDto[] | undefined;
    priceSummaries?: PriceSummaryDto[] | undefined;
    routingHeaders?: RoutingHeader[] | undefined;
}

export interface BoMItemActivityArticleDto {
    id: string | undefined;
    description: string | undefined;
    financial: ArticleFinancialDto;
}

export interface BoMItemActivityDto {
    id?: string;
    primaryWorkingStep?: WorkingStepType;
    secondaryWorkingStep?: WorkingStepType;
    resource?: SelectedResourceDto;
    isPrimaryWorkingStep?: boolean;
    usesRawMaterial?: boolean;
    notRemovable?: boolean;
    supportsArticle?: boolean;
    keywords?: { [key: string]: KeywordDto[]; } | undefined;
    article?: BoMItemActivityArticleDto;
    comment?: string | undefined;
    materialEstimatorType?: MaterialEstimatorType;
}

export interface BoMItemAttachmentDto {
    id?: string;
    fileName?: string | undefined;
    scope?: string | undefined;
    dateCreated?: Date | undefined;
    originalFileName?: string | undefined;
    thumbnail?: string | undefined;
}

export interface BoMItemReference {
    boMItemId?: string;
    boMItemType?: BoMItemType;
}

export enum BoMItemType {
    Project = "Project",
    Assembly = "Assembly",
    PartType = "PartType",
}

export interface BoMItemUpdateRequestDto {
    bomItemId?: string;
    quantity?: number;
    keywords?: { [key: string]: KeywordDto[]; } | undefined;
    comment?: string | undefined;
    drawingNumber?: string | undefined;
    revision?: string | undefined;
    name?: string | undefined;
    buyingPartyArticleNumber?: string | undefined;
    sellingPartyArticleNumber?: string | undefined;
}

export interface BomItemCheckListItem {
    itemId?: string;
    bomItemId: string;
    engineeringDrawingId: string;
    featureId: string | undefined;
    featureName: string | undefined;
    description: string | undefined;
    done: boolean;
    category: string | undefined;
    customDescription?: string | undefined;
}

export interface BomItemIdAndActivity {
    bomItemId?: string;
    activityId?: string;
}

export interface BomItemIdAndActivityId {
    bomItemId?: string;
    activityId?: string;
}

export interface BusinessRulesResponse {
    isRuleEmpty?: boolean;
    isRuleValid?: boolean;
    output?: string | undefined;
    clientInvalidData?: any | undefined;
}

export interface CadFilePattern {
    order?: number;
    property?: CadFilePatternProperties;
    pattern?: string | undefined;
}

export enum CadFilePatternProperties {
    NotInitialized = "NotInitialized",
    Thickness = "Thickness",
    Quantity = "Quantity",
    Quality = "Quality",
}

export interface ChamberOfCommerceDto {
    number?: string | undefined;
    branchNumber?: string | undefined;
    country?: CountryDto;
}

export interface ChangePartNameArgs {
    rowOrAssemblyId?: string;
    partName: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ChangePartyUserEmailAddressRequest {
    userId: string | undefined;
    emailAddress: string | undefined;
    redirectUrl?: string | undefined;
}

export interface ChangeQuantityArgs {
    quantity?: number;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ChangeSalesPersonRequest {
    userId: string | undefined;
}

export interface ChangeStatusAndPriorityArgs {
    initialStatus: string | undefined;
    targetStatus: string | undefined;
    position?: number;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ChangeTargetSalesPriceArgs {
    targetSalesPricePerItem: MoneyDto;
    id?: string;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ChangeVisibleInPortalRequest {
    visibleInPortal?: boolean;
}

export interface ClearActivityAsOutsourcedRequest {
    boMItemId?: string;
    boMItemActivityId?: string;
}

export interface ClearSupplierPartyIdRequest {
    supplierId?: string;
}

export interface ContactPersonDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface CopyWorkingStepArgs {
    sourcePartTypeId: string;
    sourceActivityId: string;
    destinationPartTypeIds: string[];
    workingStepType: WorkingStepType;
}

export interface CountryDto {
    code?: string | undefined;
    name?: string | undefined;
}

export interface CreateOrUpdateWorkingStepRouteDto {
    name: string | undefined;
    steps?: WorkingStepType[] | undefined;
}

export interface CreatePriceRequest {
    supplierId: string;
    comment: string | undefined;
    activities: CreatePriceRequestActivityRow[] | undefined;
}

export interface CreatePriceRequestActivityRow {
    bomItemId: string;
    bomItemActivityId: string;
    workingStepType: WorkingStepType;
    description: string | undefined;
    comment: string | undefined;
    attachments: CreatePriceRequestAttachment[] | undefined;
}

export interface CreatePriceRequestAttachment {
    fileName: string | undefined;
    originalFileName: string | undefined;
}

export interface CreatePriceRequestsRequest {
    priceRequests?: CreatePriceRequest[] | undefined;
}

export interface CreatePriceRequestsResponse {
    priceRequestIds?: string[] | undefined;
}

export interface CreateProjectFromRfqRequest {
}

export interface CreateProjectRequest {
    relationId?: string;
    orderNumber: string | undefined;
    projectReference: string | undefined;
    address?: AddressDto;
    deliveryAddress?: AddressDto;
    buyingCompanyName?: string | undefined;
    contactPerson?: ContactPersonDto;
    vatRatio?: QuantityDto;
    deliveryTermsCode: string | undefined;
    paymentTermsCode: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface CreateWorkspaceRequest {
    name: string | undefined;
    team: string | undefined;
    chosenTemplates?: string[] | undefined;
    enableAutoDomainJoin: boolean;
    currencyCode: string | undefined;
    workingStepTypes: WorkingStepType[] | undefined;
    languageCode?: string | undefined;
    modules: AppModule[] | undefined;
}

export interface CreateWorkspaceResponse {
    partyDto: ManagementPartyDto;
}

export interface CreatorDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface CurrencyDto {
    code: string | undefined;
    symbol: string | undefined;
    englishName: string | undefined;
}

export interface CustomerPortalWorkingStepSettingsDto {
    workingStepType?: WorkingStepType;
    availableInPortal?: boolean;
    hiddenInPortal?: boolean;
    notRemovableInPortal?: boolean;
}

export interface CuttingPlanDetailsDto {
    index?: number;
    quantity?: number;
    offsetTop: QuantityDto;
    offsetRight: QuantityDto;
    offsetBottom: QuantityDto;
    offsetLeft: QuantityDto;
    partDistance: QuantityDto;
    sheetLength: QuantityDto;
    sheetWidth: QuantityDto;
    nestedLength: QuantityDto;
    nestedWidth: QuantityDto;
    sheetUtilization?: number;
    nestedSheetUtilization?: number;
    uniquePartQuantity?: number;
    totalPartQuantity?: number;
    sheetArea: QuantityDto;
    totalPartArea: QuantityDto;
    nestableArea: QuantityDto;
    offsettedSheetUtilization?: number;
}

export interface CuttingPlanDto {
    id: number;
    quantity: number;
    fileNameOfNestingImage: string | undefined;
    details: CuttingPlanDetailsDto;
    partTypeIds: string[] | undefined;
    resourceId: string;
    articleId: string | undefined;
}

export interface CuttingPlanResult {
    id: number;
    imageFilename: string | undefined;
    imageData: string | undefined;
    quantity: number;
}

export interface DashBoardDto {
    dashboardType: string | undefined;
    dashboardUrl: string | undefined;
}

export enum DashboardType {
    Unknown = "Unknown",
    Usage = "Usage",
    CustomerBehaviour = "CustomerBehaviour",
}

export interface DeleteGeometryOperationsResponse {
    isAcknowledged?: boolean;
    deletedCount?: number;
}

export interface DeletePartyCanBuyFromRequest {
    buyingPartyId?: string;
    sellingPartyId?: string;
}

export interface DeletePartyRequest {
    partyId: string;
}

export interface DeletePartyUserRequest {
    userId: string | undefined;
}

export interface DeleteProjectsArgs {
    projectIds: string[] | undefined;
}

export interface DeleteResourceActivityEstimatorRequest {
    secondaryWorkingStep?: WorkingStepType;
}

export interface DeleteResourceActivityEstimatorResponse {
}

export interface DeleteResourceCapableResourceEstimatorResponse {
}

export interface DeleteResourceMaterialEstimatorRequest {
    secondaryWorkingStep?: WorkingStepType;
}

export interface DeleteResourceMaterialEstimatorResponse {
}

export interface DeleteSupplierActivitiesRequest {
    supplierActivities: DeleteSupplierActivity[] | undefined;
}

export interface DeleteSupplierActivity {
    supplierId: string;
    workingStepType: WorkingStepType;
}

export interface DeleteUserRequest {
    id: string | undefined;
}

export interface DeleteWorkingStepsRequest {
    itemIds: string[] | undefined;
    primaryWorkingStepsToDelete: WorkingStepType[] | undefined;
}

export interface DeliveryEstimationDto {
    numberOfDays?: number | undefined;
}

export interface DeliveryTermsDto {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface DimensionSummaryDto {
    weight?: QuantityDto;
    length3D?: QuantityDto;
    width3D?: QuantityDto;
    height3D?: QuantityDto;
    length2D?: QuantityDto;
    width2D?: QuantityDto;
    boundingBox3dPoints?: Point3dDto[] | undefined;
}

export interface DimensionsDto {
    label: string | undefined;
    measureDto: QuantityDto;
}

export enum DiscountCalculationMethodDto {
    DiscountBasedOnCostPrice = "DiscountBasedOnCostPrice",
    DiscountBasedOnCostPricePlusSurcharge = "DiscountBasedOnCostPricePlusSurcharge",
}

export interface DownloadMaterialEstimatorRequest {
    boMItemId?: string;
    boMItemActivityId?: string;
}

export interface DraftPriceRequestActivityDto {
    projectId: string;
    boMItemId: string;
    boMItemActivityId: string;
    name: string | undefined;
    workingStepType: WorkingStepType;
    supplierIds: string[] | undefined;
    attachments: DraftPriceRequestAttachmentDto[] | undefined;
    quantity: number;
}

export interface DraftPriceRequestAttachmentDto {
    fileName: string | undefined;
    originalFileName: string | undefined;
}

export interface DurationAndPercentageModel {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface EmailDNSSettingsDto {
    active?: EmailSenderDto;
    pending?: EmailSenderDto;
}

export interface EmailDomainAuthenticationDnsRecordDto {
    valid?: boolean;
    type: string | undefined;
    host: string | undefined;
    data: string | undefined;
}

export interface EmailDomainAuthenticationDto {
    domain: string | undefined;
    valid?: boolean;
    dnsRecords?: EmailDomainAuthenticationDnsRecordDto[] | undefined;
}

export interface EmailSenderDto {
    name?: string | undefined;
    email?: string | undefined;
    domainAuthentication?: EmailDomainAuthenticationDto;
}

export interface EnableImnooRequest {
    apiToken: string | undefined;
}

export interface EventLogDto {
    dateTime: Date;
    channel: string | undefined;
    source: string | undefined;
    category: string | undefined;
    severity: EventLogSeverityDto;
    message: string | undefined;
}

export enum EventLogSeverityDto {
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
}

export enum EventTypes {
    ProjectsListed = "ProjectsListed",
    ProjectOpened = "ProjectOpened",
    ProjectCreated = "ProjectCreated",
    ProjectUpdated = "ProjectUpdated",
    BomRowCreated = "BomRowCreated",
    AssemblyAdded = "AssemblyAdded",
    FileUploaded = "FileUploaded",
    EstimatorUploaded = "EstimatorUploaded",
    EstimatorDownloaded = "EstimatorDownloaded",
    ArticlesUploaded = "ArticlesUploaded",
    NestingPlanCreated = "NestingPlanCreated",
    WorkingStepAdded = "WorkingStepAdded",
    ProjectStatusChanged = "ProjectStatusChanged",
    WorkingStepRemoved = "WorkingStepRemoved",
    RemovedProjectsListed = "RemovedProjectsListed",
    RemovedProjectsRestored = "RemovedProjectsRestored",
    AddressBookUploaded = "AddressBookUploaded",
    PartyCreated = "PartyCreated",
    PartyUpdated = "PartyUpdated",
    PartyDeleted = "PartyDeleted",
    ExcelExportTemplateCreated = "ExcelExportTemplateCreated",
    ExcelExportTemplateUpdated = "ExcelExportTemplateUpdated",
    ExcelExportTemplateDeleted = "ExcelExportTemplateDeleted",
    ProjectExportedToExcelUsingTemplates = "ProjectExportedToExcelUsingTemplates",
    BoMItemAttachmentUploaded = "BoMItemAttachmentUploaded",
    UserInvited = "UserInvited",
    Werk24Completed = "Werk24Completed",
    Werk24Failed = "Werk24Failed",
    ProjectSimplified = "ProjectSimplified",
    ImnooCompleted = "ImnooCompleted",
    NestingRemnantStrategyChanged = "NestingRemnantStrategyChanged",
    ImnooFailed = "ImnooFailed",
    SuppliersUploaded = "SuppliersUploaded",
    SupplierArticlesUploaded = "SupplierArticlesUploaded",
    RecognitionError = "RecognitionError",
    AssemblyFlattened = "AssemblyFlattened",
    AgentConnected = "AgentConnected",
    AgentDisconnected = "AgentDisconnected",
    WorkingStepEstimatedTimeManuallySet = "WorkingStepEstimatedTimeManuallySet",
    WorkingStepEstimatedTimeManuallySetRemoved = "WorkingStepEstimatedTimeManuallySetRemoved",
    WorkingStepEstimatedAdditionalCostManuallySet = "WorkingStepEstimatedAdditionalCostManuallySet",
    WorkingStepEstimatedAdditionalCostManuallySetRemoved = "WorkingStepEstimatedAdditionalCostManuallySetRemoved",
    ImnooIntegrationEnabled = "ImnooIntegrationEnabled",
    ImnooIntegrationDisabled = "ImnooIntegrationDisabled",
    UserAutoJoinedParty = "UserAutoJoinedParty",
    BoMItemGeometryTypeSwitched = "BoMItemGeometryTypeSwitched",
    WorkingStepAnalyzed = "WorkingStepAnalyzed",
    ProjectReCreated = "ProjectReCreated",
    BoMItemToPurchasingPart = "BoMItemToPurchasingPart",
    EngineeringDrawingError = "EngineeringDrawingError",
    PdfPageAnalyzed = "PdfPageAnalyzed",
    EngineeringDrawingPageLinkedToBomItem = "EngineeringDrawingPageLinkedToBomItem",
    DashboardOpened = "DashboardOpened",
}

export interface ExportTemplateDto {
    id?: string;
    fileName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface ExportTemplateDtoArrayApiResponse {
    records?: ExportTemplateDto[][] | undefined;
    _meta?: ApiMetadata;
}

export interface FeatureDetailDto {
    label?: string | undefined;
    faceIds?: number[] | undefined;
    quantityValue?: QuantityDto;
    intValue?: number | undefined;
    boolValue?: boolean | undefined;
}

export interface FeatureDto {
    label?: string | undefined;
    details?: FeatureDetailDto[] | undefined;
    sections?: FeatureSectionDto[] | undefined;
}

export interface FeatureSectionDto {
    label?: string | undefined;
    details?: FeatureDetailDto[] | undefined;
    faceIds?: number[] | undefined;
}

export interface FeaturesDto {
    features?: FeatureDto[] | undefined;
    upperSideColor?: string | undefined;
    canSelectUpperSide?: boolean;
}

export interface FinancialDto {
    id?: string;
    quantity?: number;
    totalProjectQuantity?: number;
    costPricePerItem?: MoneyDto;
    costPriceOfItems?: MoneyDto;
    salesPricePerItem?: MoneyDto;
    salesPriceOfItems?: MoneyDto;
    targetSalesPricePerItem?: MoneyDto;
    discountRatio?: QuantityDto;
    discountValuePerItem?: MoneyDto;
    discountValueOfItems?: MoneyDto;
    surchargeRatio?: QuantityDto;
    surchargeValuePerItem?: MoneyDto;
    surchargeValueOfItems?: MoneyDto;
}

export interface FlattenAssemblyRequest {
    assemblyId?: string;
    convertToIndividualParts?: boolean;
}

export interface FlattenProjectRequest {
    convertToIndividualParts?: boolean;
}

export enum GeometricTolerance {
    NotApplicable = "NotApplicable",
    HFine = "HFine",
    KMedium = "KMedium",
    LCoarse = "LCoarse",
}

export interface GeometryFileDetails {
    file: string | undefined;
    quantity?: number;
    thickness?: string | undefined;
    tokens?: string[] | undefined;
    comment?: string | undefined;
}

export interface GeometryFileReferenceDto {
    storagePath: string | undefined;
    originalFileName: string | undefined;
}

export enum GeometryType {
    Unknown = "Unknown",
    Planar = "Planar",
    Cylindrical = "Cylindrical",
    Sphere = "Sphere",
    Cylinder = "Cylinder",
    RoundBar = "RoundBar",
    RoundTube = "RoundTube",
    TurnedBar = "TurnedBar",
    TurnedTube = "TurnedTube",
    SheetWithoutBending = "SheetWithoutBending",
    SheetWithBending = "SheetWithBending",
    SheetWithRolling = "SheetWithRolling",
    SquareOrRectangularBar = "SquareOrRectangularBar",
    SquareOrRectangularTubeWithRoundEdges = "SquareOrRectangularTubeWithRoundEdges",
    SquareOrRectangularTube = "SquareOrRectangularTube",
    UProfileWithRoundEdges = "UProfileWithRoundEdges",
    AngleProfileWithRoundedEdge = "AngleProfileWithRoundedEdge",
    LProfile = "LProfile",
    UProfile = "UProfile",
    OmegaProfile = "OmegaProfile",
    AngleProfile = "AngleProfile",
    HorIProfile = "HorIProfile",
    TProfile = "TProfile",
    IProfile = "IProfile",
    TriangularBar = "TriangularBar",
    TriangularBarWithBending = "TriangularBarWithBending",
    PurchasingPart = "PurchasingPart",
    WeldingBeam = "WeldingBeam",
    RoundTubeWithBending = "RoundTubeWithBending",
    SquareOrRectangularTubeWithBending = "SquareOrRectangularTubeWithBending",
    RoundBarWithBending = "RoundBarWithBending",
    MillingPart = "MillingPart",
    CProfile = "CProfile",
    HexagonalBar = "HexagonalBar",
}

export enum GeometryTypeCategoryDto {
    Unknown = "Unknown",
    Bar = "Bar",
    Tube = "Tube",
    Sheet = "Sheet",
    Profile = "Profile",
    Milling = "Milling",
    Turning = "Turning",
}

export enum GeometryTypeDto {
    Unknown = "Unknown",
    Planar = "Planar",
    Cylindrical = "Cylindrical",
    Sphere = "Sphere",
    Cylinder = "Cylinder",
    RoundBar = "RoundBar",
    RoundTube = "RoundTube",
    TurnedBar = "TurnedBar",
    TurnedTube = "TurnedTube",
    SheetWithoutBending = "SheetWithoutBending",
    SheetWithBending = "SheetWithBending",
    SheetWithRolling = "SheetWithRolling",
    SquareOrRectangularBar = "SquareOrRectangularBar",
    SquareOrRectangularTubeWithRoundEdges = "SquareOrRectangularTubeWithRoundEdges",
    SquareOrRectangularTube = "SquareOrRectangularTube",
    UProfileWithRoundEdges = "UProfileWithRoundEdges",
    AngleProfileWithRoundedEdge = "AngleProfileWithRoundedEdge",
    LProfile = "LProfile",
    UProfile = "UProfile",
    OmegaProfile = "OmegaProfile",
    AngleProfile = "AngleProfile",
    HorIProfile = "HorIProfile",
    TProfile = "TProfile",
    IProfile = "IProfile",
    TriangularBar = "TriangularBar",
    TriangularBarWithBending = "TriangularBarWithBending",
    PurchasingPart = "PurchasingPart",
    WeldingBeam = "WeldingBeam",
    RoundTubeWithBending = "RoundTubeWithBending",
    SquareOrRectangularTubeWithBending = "SquareOrRectangularTubeWithBending",
    RoundBarWithBending = "RoundBarWithBending",
    MillingPart = "MillingPart",
    CProfile = "CProfile",
    HexagonalBar = "HexagonalBar",
}

export interface GetArticleSelectionEnabledInPortalResponse {
    articleSelectionEnabledInPortal?: boolean;
}

export interface GetAvailableDeliveryDaysResponse {
    noDeliveryDate?: { [key: string]: string; } | undefined;
}

export interface GetAvailableWorkspacesResponse {
    canEnableAutoJoin: boolean;
    availableWorkspaces: AvailableWorkspace[] | undefined;
}

export interface GetBusinessRulesSettingsResponse {
    lengthUnit: LengthUnit;
    massUnit: MassUnit;
    areaUnit: AreaUnit;
    volumeUnit: VolumeUnit;
}

export interface GetCustomersWithAccessResponse {
    customers?: SelectableCustomerDto[] | undefined;
}

export interface GetDeliveryTermsResponse {
    records: DeliveryTermsDto[] | undefined;
}

export interface GetDraftPriceRequestResponse {
    draft: ProjectPriceRequestDraftDto;
}

export interface GetGeometryOperationsResponse {
    totalQueued?: number;
    totalStarted?: number;
    totalFinished?: number;
    totalFailed?: number;
    records?: ProjectOperationDto[] | undefined;
    _meta?: ApiMetadata;
}

export interface GetGeometrySelectionEnabledInPortalResponse {
    geometrySelectionEnabledInPortal?: boolean;
}

export interface GetIncomingPriceRequestsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: IncomingPriceRequestDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetNestingEngineResponse {
    nestingEngine: string | undefined;
}

export interface GetNestingRequest {
    resourceId: string;
    materialId: string | undefined;
}

export interface GetNestingSettingsResponse {
    lengthDimensions: OneDimensionNestingSettingsDto[] | undefined;
    sheetDimensions: TwoDimensionNestingSizeDto[] | undefined;
}

export interface GetOperationSummaryResponse {
    isNesting?: boolean;
    isExportingToErp?: boolean;
    isManufacturabilityCheckRunning?: boolean;
    isImnooIntegrationWorkloadRunning?: boolean;
    isEstimating?: boolean;
}

export interface GetOutgoingPriceRequestsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: PriceRequestDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetPartyCalculationSettingsResponse {
    discountCalculationMethod?: DiscountCalculationMethodDto;
}

export interface GetPartyCurrencyResponse {
    baseCurrency: CurrencyDto;
    selectedCurrencies: SelectedPartyCurrencyDto[] | undefined;
    selectableCurrencies: SelectablePartyCurrencyDto[] | undefined;
}

export interface GetPartyDashboardsResponse {
    dashboards?: DashBoardDto[] | undefined;
}

export interface GetPartyDefaultLengthSettingsResponse {
    selectedLengthUnit?: string | undefined;
    supportedLengthUnits?: string[] | undefined;
}

export interface GetPartyMachiningSettingsResponse {
    roundBarMinimumOffset: QuantityDto;
    roundBarMaximumOffset: QuantityDto;
    squareBarMinimumOffset: QuantityDto;
    squareBarMaximumOffset: QuantityDto;
    machiningPartLenghtPercentage: QuantityDto;
    sawingRoundBarMinimumOffset: QuantityDto;
    sawingRoundBarMaximumOffset: QuantityDto;
    sawingSquareBarMinimumOffset: QuantityDto;
    sawingSquareBarMaximumOffset: QuantityDto;
    lengthMargin: QuantityDto;
    widthMargin: QuantityDto;
    heightMargin: QuantityDto;
    diameterMargin: QuantityDto;
}

export interface GetPartyProvideRawMaterialSettingsResponse {
    validWorkingStepTypes: WorkingStepType[] | undefined;
    selected: WorkingStepType[] | undefined;
}

export interface GetPartySettingsAvailableDeliveryDaysResponse {
    noDeliveryDate: { [key: string]: string; } | undefined;
}

export interface GetPartyStepSettingsResponse {
    stepExtensionSetting?: StepExtensionSettingEnumDto;
}

export interface GetPaymentTermsResponse {
    records: PaymentTermsDto[] | undefined;
}

export interface GetPossibleGeometryTypesResponse {
    possibleGeometryTypes: GeometryType[] | undefined;
}

export interface GetProjectCancelSettingsResponse {
    retentionDaysWhenDefining?: number | undefined;
    retentionDaysWhenRequested?: number | undefined;
    retentionDaysWhenQuoting?: number | undefined;
    retentionDaysWhenQuoted?: number | undefined;
}

export interface GetProjectEstimationTemplateResponse {
    lastUpdatedAt?: Date | undefined;
    fileName?: string | undefined;
}

export interface GetProjectOperationsResponse {
    totalQueued?: number;
    totalStarted?: number;
    totalFinished?: number;
    totalFailed?: number;
    records?: ProjectOperationDto[] | undefined;
    _meta?: ApiMetadata;
}

export interface GetProjectPriceRequestsResponse {
    priceRequestDtos: PriceRequestDto[] | undefined;
}

export interface GetProjectProvideRawMaterialSettingsResponse {
    selected: ProjectProvideRawMaterialSettingDto[] | undefined;
    validWorkingStepTypes: WorkingStepType[] | undefined;
}

export interface GetProjectSummariesResponse {
    projectList: ProjectSummaryDto[] | undefined;
    projectStates: ProjectStateDto[] | undefined;
}

export interface GetProjectSummariesResponsePaged {
    projectStates: ProjectStateDto[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    details: ProjectSummaryDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetQuotationsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: QuotationDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetRemovedProjectSummariesResponse {
    projectList: ProjectSummaryDto[] | undefined;
    projectStates: ProjectStateDto[] | undefined;
}

export interface GetRequestForQuotationsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: RequestForQuotationDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetResourceDiscountAndSurchargeResponse {
    resourceId: string;
    segmentedDiscounts: SegmentedResourceScaledDiscountsDto[] | undefined;
    scaledDiscounts: ScaledDurationAndPercentageDto[] | undefined;
    scaledSurcharges: ScaledDurationAndPercentageDto[] | undefined;
}

export interface GetSelectableCustomersResponse {
    customers?: SelectableCustomerDto[] | undefined;
}

export interface GetSelectableDeliveryTermsResponse {
    records: DeliveryTermsDto[] | undefined;
}

export interface GetSelectablePaymentTermsResponse {
    records: PaymentTermsDto[] | undefined;
}

export interface GetSupplierArticleImportJobsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: SupplierArticlesImportJobDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetSupplierArticlesResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: SupplierArticleDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetSupplierManagementImportJobsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: SupplierManagementImportJobDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetSupplierManagementResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: SupplierManagementDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetSuppliersActivitiesResponse {
    supportedActivities: WorkingStepType[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    details: SupplierActivityDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetSystemPartiesResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: ManagementPartyDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetTimeRegistrationImportJobsResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: TimeRegistrationImportJobDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetTimeRegistrationResponse {
    page: number;
    pageSize: number;
    totalCount: number;
    details: ProductionTimeAggregationDto[] | undefined;
    _links?: PagingLinks;
    _sortFields?: string[] | undefined;
}

export interface GetUpperSideSelectionSettingsResponse {
    color: string | undefined;
}

export interface GetWorkspaceResponse {
    defaultLengthAbbreviation: string | undefined;
    hasSupportChat: boolean;
    modules: AppModule[] | undefined;
    allowedImportDocumentTypes: ImportDocumentType[] | undefined;
    dateFormat: string | undefined;
}

export enum GrossPriceSource {
    NotInitialized = "NotInitialized",
    CatalogPrice = "CatalogPrice",
    HousePrice = "HousePrice",
    CloudPrice = "CloudPrice",
}

export interface GroupPartTypeIdsArgs {
    assemblyId?: string;
    partIds?: string[] | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ImageTokenResponse {
    token?: string | undefined;
    expires?: Date;
}

export interface ImnooAvailableResourceDto {
    id: string;
    name: string | undefined;
}

export interface ImnooDto {
    enabled?: boolean;
    apiToken: string | undefined;
    resourceMappings?: ImnooResourceMappingDto[] | undefined;
    materialMappings?: ImnooMaterialMappingDto[] | undefined;
    availableMaterials?: string[] | undefined;
    availableImnooMaterials?: string[] | undefined;
    availableResources?: ImnooAvailableResourceDto[] | undefined;
    availableImnooResources?: ImnooAvailableResourceDto[] | undefined;
    usePartNameAsArticleNumber?: boolean;
    useBuyingPartyPrefixInArticleName?: boolean;
    autofillArticleWithTwoDDrawingData?: boolean;
    useBuyingPartyNameInDrawingIndex?: boolean;
}

export interface ImnooGetAvailableMaterialResponse {
    availableMaterials?: string[] | undefined;
    availableImnooMaterials?: string[] | undefined;
}

export interface ImnooMaterialMappingDto {
    keyword: string | undefined;
    imnooMaterialName: string | undefined;
}

export interface ImnooMaterialMappingModel {
    keyword: string | undefined;
    imnooMaterialName: string | undefined;
}

export interface ImnooResourceMappingDto {
    resourceId: string;
    resourceName: string | undefined;
    imnooMachineId: string;
}

export interface ImnooResourceMappingModel {
    resourceId?: string;
    imnooMachineId?: string;
}

export enum ImportDocumentType {
    NotInitialized = "NotInitialized",
    UblRequestForQuotation = "UblRequestForQuotation",
    ExcelBillOfMaterial = "ExcelBillOfMaterial",
    GeometryStep = "GeometryStep",
    GeometryDxf = "GeometryDxf",
    GeometrySolidWorks = "GeometrySolidWorks",
    GeometryJt = "GeometryJt",
    GeometryEye = "GeometryEye",
    GeometryDwg = "GeometryDwg",
    GeometryPdf = "GeometryPdf",
    GeometryDstv = "GeometryDstv",
    UblCatalogue = "UblCatalogue",
}

export interface IncomingPriceRequestActivityRowDto {
    id: string;
    sourcePriceRequestActivityRowId: string | undefined;
    workingStepType: WorkingStepType;
    geometryFile: GeometryFileReferenceDto;
    quantity: number;
    description: string | undefined;
    comment: string | undefined;
    attachments: AttachmentDto[] | undefined;
    uploadRequestId: string | undefined;
    bomItemId: string | undefined;
    totalSalesPrice: number | undefined;
}

export interface IncomingPriceRequestDto {
    id: string;
    sourcePriceRequestId: string | undefined;
    externalReference: string | undefined;
    requesterPartyId: string;
    ownerPartyId: string;
    supplierProjectId: string | undefined;
    status: string | undefined;
    comment: string | undefined;
    activities: IncomingPriceRequestActivityRowDto[] | undefined;
    dateCreated: Date;
    dateChanged: Date;
}

export interface InsertOrUpdateTemplateArgs {
    file: string | undefined;
    languageCode: string | undefined;
}

export interface IntegrationDto {
    id: string;
    name: string | undefined;
    enabled: boolean;
}

export interface IntegrationSettingDto {
    name: string | undefined;
    hidden: boolean;
    required: boolean;
    value: any | undefined;
    valueType?: IntegrationSettingDtoValueType;
}

export enum IntegrationSettingDtoValueType {
    Number = "Number",
    Text = "Text",
}

export enum IntegrationType {
    NotInitialized = "NotInitialized",
    ERP_ECI_RidderIQ = "ERP_ECI_RidderIQ",
    CAM_LVD_CadmanB = "CAM_LVD_CadmanB",
    CAM_WiCAM_PN4000 = "CAM_WiCAM_PN4000",
    CAM_BySoft_CAM = "CAM_BySoft_CAM",
    ERP_ISAH_ISAH = "ERP_ISAH_ISAH",
    CAM_Trumpf_TruTops_Boost = "CAM_Trumpf_TruTops_Boost",
    MES_Trumpf_TruTops_Fab = "MES_Trumpf_TruTops_Fab",
    ERP_ECI_Bemet = "ERP_ECI_Bemet",
    Custom = "Custom",
    ERP_Lantek_Integra = "ERP_Lantek_Integra",
    FCC_AutoPOL = "FCC_AutoPOL",
    CAM_LVD_CadmanSdi = "CAM_LVD_CadmanSdi",
    ERP_MKG_V3 = "ERP_MKG_V3",
    ERP_MKG_V4 = "ERP_MKG_V4",
    ERP_MKG_V5 = "ERP_MKG_V5",
    Feat_Selling_Buying_ArticleNumber_Sync = "Feat_Selling_Buying_ArticleNumber_Sync",
}

export interface InvitationDto {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    dateCreated: Date;
    inviteLink: string | undefined;
}

export enum IssueCode {
    NotInitialized = "NotInitialized",
    MaterialNotSet = "MaterialNotSet",
    WorkingStepNotSet = "WorkingStepNotSet",
    MaterialCostPriceNotSet = "MaterialCostPriceNotSet",
    WorkingStepCostPriceNotSet = "WorkingStepCostPriceNotSet",
    ResourceNotSet = "ResourceNotSet",
    EstimationNotValid = "EstimationNotValid",
    OuterContour2dNotSet = "OuterContour2dNotSet",
    ProductionTimeNotSet = "ProductionTimeNotSet",
    ManufacturabilityCheckFailed = "ManufacturabilityCheckFailed",
    ExportToErpFailed = "ExportToErpFailed",
    PartDoesNotFitInMaterial = "PartDoesNotFitInMaterial",
    Other = "Other",
    MaterialAndManualCostPriceNotSet = "MaterialAndManualCostPriceNotSet",
    MultipleArticlesFound = "MultipleArticlesFound",
    AnalysisFailed = "AnalysisFailed",
    NestingFailed = "NestingFailed",
    WorkingStepNotAvailable = "WorkingStepNotAvailable",
    SheetCuttingToolPathsMissing = "SheetCuttingToolPathsMissing",
    WorkingStepUsingRawMaterialMissing = "WorkingStepUsingRawMaterialMissing",
    MaterialEstimationNotValid = "MaterialEstimationNotValid",
    ProjectCalculationFailed = "ProjectCalculationFailed",
    UpperSideNotSelected = "UpperSideNotSelected",
    UpperSideSelectedNotNeeded = "UpperSideSelectedNotNeeded",
    WorkingStepsHourlyRatesNotSet = "WorkingStepsHourlyRatesNotSet",
    CannotNestOnMaterialWithoutDimensions = "CannotNestOnMaterialWithoutDimensions",
    RawMaterialThicknessMismatch = "RawMaterialThicknessMismatch",
}

export interface IssueDto {
    id?: string;
    description?: string | undefined;
    customDescription?: string | undefined;
    severity?: IssueSeverity;
    issueCode?: IssueCode;
    itemId?: string;
    metadata?: any | undefined;
    aggregateLevel?: AggregateLevel;
}

export enum IssueSeverity {
    NotInitialized = "NotInitialized",
    None = "None",
    Warning = "Warning",
    Error = "Error",
    NotManufacturable = "NotManufacturable",
}

export interface JoinWorkspaceRequest {
    workspaceId?: string;
}

export interface JoinWorkspaceResponse {
    partyDto: ManagementPartyDto;
}

export interface JsonSchema {
    $schema?: string | undefined;
    id?: string | undefined;
    title?: string | undefined;
    type?: any | undefined;
    discriminator?: any | undefined;
    description?: string | undefined;
    format?: string | undefined;
    default?: any | undefined;
    multipleOf?: number | undefined;
    maximum?: number | undefined;
    minimum?: number | undefined;
    maxLength?: number | undefined;
    minLength?: number | undefined;
    pattern?: string | undefined;
    maxItems?: number;
    minItems?: number;
    uniqueItems?: boolean;
    maxProperties?: number;
    minProperties?: number;
    "x-deprecated"?: boolean;
    "x-deprecatedMessage"?: string | undefined;
    "x-abstract"?: boolean;
    "x-nullable"?: boolean | undefined;
    "x-example"?: any | undefined;
    "x-enumFlags"?: boolean;
    "x-dictionaryKey"?: JsonSchema;
    xml?: JsonXmlObject;
    not?: JsonSchema;
    exclusiveMaximum?: any | undefined;
    exclusiveMinimum?: any | undefined;
    additionalItems?: any | undefined;
    additionalProperties?: any | undefined;
    items?: any | undefined;
    required?: string[];
    properties?: { [key: string]: JsonSchemaProperty; };
    patternProperties?: { [key: string]: JsonSchemaProperty; };
    definitions?: { [key: string]: JsonSchema; };
    "x-enum-names"?: string[];
    "x-enum-varnames"?: string[];
    "x-enumNames"?: string[];
    "x-enumDescriptions"?: any;
    "x-enum-descriptions"?: any;
    enum?: (any | undefined)[];
    allOf?: JsonSchema[];
    anyOf?: JsonSchema[];
    oneOf?: JsonSchema[];
    $ref?: string;

    [key: string]: any;
}

export interface JsonSchemaObjects {
    schema?: JsonSchema;
    uiSchema?: JsonSchema;
}

export interface JsonSchemaProperty {
    $schema?: string | undefined;
    id?: string | undefined;
    title?: string | undefined;
    type?: any | undefined;
    discriminator?: any | undefined;
    "x-readOnly"?: boolean;
    "x-writeOnly"?: boolean;
    description?: string | undefined;
    format?: string | undefined;
    default?: any | undefined;
    multipleOf?: number | undefined;
    maximum?: number | undefined;
    minimum?: number | undefined;
    maxLength?: number | undefined;
    minLength?: number | undefined;
    pattern?: string | undefined;
    maxItems?: number;
    minItems?: number;
    uniqueItems?: boolean;
    maxProperties?: number;
    minProperties?: number;
    "x-deprecated"?: boolean;
    "x-deprecatedMessage"?: string | undefined;
    "x-abstract"?: boolean;
    "x-nullable"?: boolean | undefined;
    "x-example"?: any | undefined;
    "x-enumFlags"?: boolean;
    "x-dictionaryKey"?: JsonSchema;
    xml?: JsonXmlObject;
    not?: JsonSchema;
    exclusiveMaximum?: any | undefined;
    exclusiveMinimum?: any | undefined;
    additionalItems?: any | undefined;
    additionalProperties?: any | undefined;
    items?: any | undefined;
    required?: string[];
    properties?: { [key: string]: JsonSchemaProperty; };
    patternProperties?: { [key: string]: JsonSchemaProperty; };
    definitions?: { [key: string]: JsonSchema; };
    "x-enum-names"?: string[];
    "x-enum-varnames"?: string[];
    "x-enumNames"?: string[];
    "x-enumDescriptions"?: any;
    "x-enum-descriptions"?: any;
    enum?: (any | undefined)[];
    allOf?: JsonSchema[];
    anyOf?: JsonSchema[];
    oneOf?: JsonSchema[];
    $ref?: string;

    [key: string]: any;
}

export interface JsonXmlObject {
    name?: string | undefined;
    wrapped?: boolean;
    namespace?: string | undefined;
    prefix?: string | undefined;
    attribute?: boolean;
}

export interface KeywordDto {
    originalKeyword?: string | undefined;
    category?: string | undefined;
    translationKey?: string | undefined;
    translationArgument?: any | undefined;
}

export interface KeywordGroupDto {
    keywordGroups?: { [key: string]: KeywordDto[]; } | undefined;
}

export interface LanguageDto {
    code: string | undefined;
    description: string | undefined;
}

export enum LengthUnit {
    Undefined = "Undefined",
    AstronomicalUnit = "AstronomicalUnit",
    Centimeter = "Centimeter",
    Chain = "Chain",
    Decimeter = "Decimeter",
    DtpPica = "DtpPica",
    DtpPoint = "DtpPoint",
    Fathom = "Fathom",
    Foot = "Foot",
    Hand = "Hand",
    Hectometer = "Hectometer",
    Inch = "Inch",
    KilolightYear = "KilolightYear",
    Kilometer = "Kilometer",
    Kiloparsec = "Kiloparsec",
    LightYear = "LightYear",
    MegalightYear = "MegalightYear",
    Megaparsec = "Megaparsec",
    Meter = "Meter",
    Microinch = "Microinch",
    Micrometer = "Micrometer",
    Mil = "Mil",
    Mile = "Mile",
    Millimeter = "Millimeter",
    Nanometer = "Nanometer",
    NauticalMile = "NauticalMile",
    Parsec = "Parsec",
    PrinterPica = "PrinterPica",
    PrinterPoint = "PrinterPoint",
    Shackle = "Shackle",
    SolarRadius = "SolarRadius",
    Twip = "Twip",
    UsSurveyFoot = "UsSurveyFoot",
    Yard = "Yard",
}

export enum LinearAndAngleTolerance {
    NotApplicable = "NotApplicable",
    Fine = "Fine",
    Medium = "Medium",
    Coarse = "Coarse",
    VeryCoarse = "VeryCoarse",
}

export interface MainStandardDto {
    name: string | undefined;
    materialNumbers: MaterialNumberDto[] | undefined;
}

export interface ManagementPartyDto {
    id: string;
    name: string | undefined;
    currencyCode: string | undefined;
    coCKey: string | undefined;
    hasSubscription: boolean;
    hasSelfServicePortal: boolean;
    hasSupportChat: boolean;
    hasSelfServicePortalSupportChat: boolean;
    isCreatedOn: Date | undefined;
    createdById: string | undefined;
    createdByEmail: string | undefined;
    modules: AppModule[] | undefined;
    dateFormat: string | undefined;
}

export interface ManualCancelProjectsRequest {
    filterDate?: Date;
    projectStatesToProcess?: ProjectStates[] | undefined;
}

export interface ManualOneTimeSetupRequest {
    sellingPartyId: string;
    currencyCode: string | undefined;
    workingStepTypes: WorkingStepType[] | undefined;
    languageCode?: string | undefined;
}

export interface ManualOneTimeSetupResponse {
    partyDto: ManagementPartyDto;
}

export interface ManuallySetAdditionalCostsArgs {
    primaryWorkingStep?: WorkingStepType;
    secondaryWorkingStep?: WorkingStepType;
    additionalCosts: MoneyDto;
    priceScope?: PriceScope;
}

export interface ManuallySetProductionTimeArgs {
    primaryWorkingStep?: WorkingStepType;
    secondaryWorkingStep?: WorkingStepType;
    productionTime: QuantityDto;
    priceScope?: PriceScope;
}

export enum MassUnit {
    Undefined = "Undefined",
    Centigram = "Centigram",
    Decagram = "Decagram",
    Decigram = "Decigram",
    EarthMass = "EarthMass",
    Grain = "Grain",
    Gram = "Gram",
    Hectogram = "Hectogram",
    Kilogram = "Kilogram",
    Kilopound = "Kilopound",
    Kilotonne = "Kilotonne",
    LongHundredweight = "LongHundredweight",
    LongTon = "LongTon",
    Megapound = "Megapound",
    Megatonne = "Megatonne",
    Microgram = "Microgram",
    Milligram = "Milligram",
    Nanogram = "Nanogram",
    Ounce = "Ounce",
    Pound = "Pound",
    ShortHundredweight = "ShortHundredweight",
    ShortTon = "ShortTon",
    Slug = "Slug",
    SolarMass = "SolarMass",
    Stone = "Stone",
    Tonne = "Tonne",
}

export enum MaterialEstimatorType {
    NotInitialized = "NotInitialized",
    None = "None",
    Nesting = "Nesting",
    Excel = "Excel",
}

export enum MaterialEstimatorTypeDto {
    NotInitialized = "NotInitialized",
    None = "None",
    Nesting = "Nesting",
    Excel = "Excel",
}

export interface MaterialHeaderDto {
    id?: string | undefined;
    cuttingPlans?: CuttingPlanDto[] | undefined;
    partTypeIds?: string[] | undefined;
    supportsRemnantCustomization?: boolean;
    materialId?: string | undefined;
    materialDescription?: string | undefined;
    materialPrice?: MoneyPerQuantityDto;
    workingStep?: WorkingStepDto;
    materialKeywords?: { [key: string]: KeywordDto[]; } | undefined;
    isRawMaterialProvided: boolean | undefined;
    weight?: QuantityDto;
}

export interface MaterialNumberDto {
    materialNumber: string | undefined;
    standards: StandardDto[] | undefined;
}

export interface MaterialScaledDiscountDto {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface MaterialScaledDiscountsAndSurchargesDto {
    material: string | undefined;
    scaledDiscounts?: MaterialScaledDiscountDto[] | undefined;
    segmentedDiscounts?: SegmentedMaterialScaledDiscountsDto[] | undefined;
    scaledSurcharges?: MaterialScaledSurchargeDto[] | undefined;
}

export interface MaterialScaledSurchargeDto {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface MaterialSelectorDto {
    selectableTokens?: { [key: string]: KeywordDto[]; } | undefined;
    selectedTokens?: KeywordDto[] | undefined;
    materials?: MaterialSummaryDto[] | undefined;
}

export interface MaterialSummaryDto {
    id?: string | undefined;
    description?: string | undefined;
    tokens?: { [key: string]: KeywordDto[]; } | undefined;
    financial?: ArticleDataFinancialDto;
    isCustomPrice?: boolean;
}

export interface MaterialsAndStandardsDto {
    materialGroup: string | undefined;
    mainStandards: MainStandardDto[] | undefined;
}

export interface MenuItem {
    id?: string | undefined;
    displayName?: string | undefined;
    sourceName?: string | undefined;
    description?: string | undefined;
}

export interface MoneyDto {
    value?: number;
    currency?: string | undefined;
    symbol?: string | undefined;
}

export interface MoneyPerQuantityDto {
    money: MoneyDto;
    quantity: QuantityDto;
}

export interface MoveWorkingStepRouteRequest {
    moveAfterRouteId?: string | undefined;
}

export enum NestingDirection {
    NotInitialized = "NotInitialized",
    Free = "Free",
    X = "X",
    Y = "Y",
}

export interface NestingEngineResponse {
    nestEngine: string | undefined;
}

export interface NestingParamsDto {
    distanceBetweenParts: QuantityDto;
    topOffset: QuantityDto;
    bottomOffset: QuantityDto;
    leftOffset: QuantityDto;
    rightOffset: QuantityDto;
    remnantType: NestingRemnantType;
    nestingRemnantWidth: QuantityDto;
    nestingRemnantArea: QuantityDto;
    maxTimeLimit: QuantityDto;
    preferedMaterialWidth: QuantityDto;
    preferedMaterialLength: QuantityDto;
    preferedMaterialHeight: QuantityDto;
    circularHoleDiameterToThicknessRatio: QuantityDto;
}

export enum NestingRemnantType {
    NoRemnant = "NoRemnant",
    CleanCut = "CleanCut",
    CleanCutHorizontal = "CleanCutHorizontal",
    CleanCutVertical = "CleanCutVertical",
    Rectangular = "Rectangular",
}

export enum NestingRemnantTypeV2 {
    NoRemnant = "NoRemnant",
    CleanCut = "CleanCut",
    CleanCutHorizontal = "CleanCutHorizontal",
    CleanCutVertical = "CleanCutVertical",
    Rectangular = "Rectangular",
    TrueShape = "TrueShape",
}

export interface NestingResult {
    materialId: string | undefined;
    resourceId: string;
    remnantSettings: RemnantSettings;
    cuttingPlans?: CuttingPlanResult[] | undefined;
}

export interface NewTemplateRequest {
    name: string | undefined;
    description: string | undefined;
    file: string | undefined;
}

export interface OneDimensionNestingSettingsDto {
    length: QuantityDto;
}

export interface PagingLinks {
    current?: string | undefined;
    next?: string | undefined;
    previous?: string | undefined;
}

export interface PartyCanBuyFromDto {
    id: string;
    name: string | undefined;
}

export interface PartyDto {
    partyId?: string;
    relationId?: string;
    address?: AddressDto;
    deliveryAddress?: AddressDto;
    legalName?: string | undefined;
    contactPerson?: ContactPersonDto;
    vatRatio?: QuantityDto;
}

export interface PartyDxfSettingsDto {
    addUnfoldedDXFAsAttachment?: boolean;
    colors?: string[] | undefined;
}

export interface PartyInviteDto {
    id?: string;
    buyerPartyId?: string;
    buyerPartyName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    dateCreated?: Date;
    status?: PartyInviteDtoStatus;
}

export enum PartyInviteDtoStatus {
    New = "New",
    Accepted = "Accepted",
}

export interface PartyProfileDto {
    legalName?: string | undefined;
    address?: AddressDto;
    chamberOfCommerce?: ChamberOfCommerceDto;
    vatNumber?: string | undefined;
    bicOrSwiftCode?: string | undefined;
    iban?: string | undefined;
    vatPercentage?: QuantityDto;
    dateFormat?: string | undefined;
}

export interface PartySearchResult {
    readonly searchKey?: string | undefined;
    id?: string;
    coCCode: string | undefined;
    addresses: string[] | undefined;
    names: string[] | undefined;
    code: string | undefined;
    deliveryTermsCode: string | undefined;
    paymentTermsCode: string | undefined;
}

export interface PartySegmentDto {
    id: string;
    name: string | undefined;
}

export interface PartySettingGeometrySelectionEnabledInPortalRequest {
    geometrySelectionEnabledInPortal?: boolean;
}

export interface PartySettingsArticleSelectionEnabledInPortalRequest {
    articleSelectionEnabledInPortal?: boolean;
}

export interface PartySettingsChangeVisibleInPortalRequest {
    visibleInPortal?: boolean;
}

export interface PartySettingsSetDashboardRequest {
    dashboardType?: DashboardType;
    dashboardUrl: string | undefined;
}

export interface PartySummaryDto {
    id?: string;
    name: string | undefined;
    isBuyingParty?: boolean;
}

export interface PartyUserDto {
    id: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    emailVerified: boolean | undefined;
    picture: string | undefined;
    role: string | undefined;
    isSysAdmin: boolean;
}

export interface PartyUserResetPasswordRequest {
    emailAddress: string | undefined;
    userId: string | undefined;
    portalThemeCustomization?: PortalThemeCustomization;
}

export interface PaymentTermsDto {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface PdfFeature {
    id: string;
    name: string | undefined;
    clipboardContent: string | undefined;
    highlights: SvgShape[] | undefined;
    category: string | undefined;
}

export interface PdfPage {
    pageId: string;
    originalFileName: string | undefined;
    pageNumber: number;
    image: string | undefined;
    features: PdfFeature[] | undefined;
}

export interface PdfViewerModel {
    bomItemId?: string;
    pages?: PdfPage[] | undefined;
}

export interface Point3dDto {
    x?: number;
    y?: number;
    z?: number;
}

export interface PortalInfo {
    companyName: string | undefined;
    url: string | undefined;
}

export interface PortalSettings {
    url: string | undefined;
    shallBeamNotifications: boolean;
    allowedImportDocumentTypes: ImportDocumentType[] | undefined;
}

export interface PortalThemeCustomization {
    sellingPartyLogoSrc: string | undefined;
    primaryColor: string | undefined;
    pageBackground: string | undefined;
    pageBackgroundImage: string | undefined;
}

export interface PrecisionsDto {
    geometricTolerance?: ToleranceInfo;
    surfaceRoughness?: ToleranceInfo;
    linearAndAngleTolerance?: ToleranceInfo;
}

export interface PriceRequestActivityRowDto {
    id: string;
    bomItemId: string;
    bomItemActivityId: string;
    workingStepType: WorkingStepType;
    geometryFile: GeometryFileReferenceDto;
    quantity: number;
    description: string | undefined;
    comment: string | undefined;
    attachments: AttachmentDto[] | undefined;
    result: PriceRequestActivityRowResultDto;
}

export interface PriceRequestActivityRowResultDto {
    totalSalesPrice: number;
}

export interface PriceRequestDto {
    id: string;
    ownerPartyId: string;
    projectId: string;
    status: PriceRequestStatusDto;
    comment: string | undefined;
    supplierId: string;
    activities: PriceRequestActivityRowDto[] | undefined;
    dateCreated: Date;
    dateChanged: Date;
}

export enum PriceRequestStatusDto {
    New = "New",
    Started = "Started",
    Cancelled = "Cancelled",
    Done = "Done",
}

export interface PriceRequestSupplierDto {
    id: string;
    name: string | undefined;
}

export interface PriceRowDto {
    description?: string | undefined;
    costPrice?: MoneyDto;
    productionTimeCosts?: MoneyDto;
    costPriceIsManuallySet?: boolean;
    discountValue?: MoneyDto;
    surchargeValue?: MoneyDto;
    discountRatio?: QuantityDto;
    surchargeRatio?: QuantityDto;
    salesPrice?: MoneyDto;
    canObtainExplanation?: boolean;
    isWorkingStep?: boolean;
    workingStep?: WorkingStepDto;
    workingStepType?: WorkingStepType;
    isTotalRow?: boolean;
    productionTime?: QuantityDto;
    productionTimeManuallySet?: QuantityDto;
    additionalProductionCosts?: MoneyDto;
    additionalProductionCostsManuallySet?: MoneyDto;
    costsAreShared?: boolean;
    rate?: MoneyPerQuantityDto;
    canManualEditCostPrice?: boolean;
    canManualEditSurchargeDiscount?: boolean;
    isBatchIndependent?: boolean;
    children?: PriceRowDto[] | undefined;
    materialId?: string | undefined;
    resourceId?: string;
    canDownloadMaterialEstimator: boolean;
}

export interface PriceRowsDto {
    priceRows?: PriceRowDto[] | undefined;
}

export enum PriceScope {
    NotInitialized = "NotInitialized",
    Unit = "Unit",
    Batch = "Batch",
    Total = "Total",
}

export interface PriceSummaryCostPriceDto {
    quantity?: QuantityDto;
    price?: MoneyPerQuantityDto;
    selected?: boolean;
}

export interface PriceSummaryDto {
    rate?: MoneyPerQuantityDto;
    totalCostPrice: MoneyDto;
    productionTimeCosts: MoneyDto;
    additionalCosts: MoneyDto;
    description?: string | undefined;
    isMaterial?: boolean;
    isWorkingStep?: boolean;
    workingStep?: WorkingStepDto;
    materialId?: string | undefined;
    discountValue: MoneyDto;
    surchargeValue: MoneyDto;
    discountRatio: QuantityDto;
    surchargeRatio: QuantityDto;
    productionTime?: QuantityDto;
    weight?: QuantityDto;
    isDiscountManuallySet?: boolean;
    isSurchargeManuallySet?: boolean;
    isCostPriceManuallySet?: boolean;
    totalSalesPrice: MoneyDto;
    costsAreShared?: boolean;
    isPurchasePart?: boolean;
    isPurchasePartWithoutArticle?: boolean;
    staggeredCostPrices?: PriceSummaryCostPriceDto[] | undefined;
    totalQuantity?: QuantityDto;
    staggeredQuantity?: QuantityDto;
    staggeredTotalQuantity?: QuantityDto;
    canEditDiscountOrSurcharge?: boolean;
    workingStepsUsingMaterial?: WorkingStepType[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProductionTimeAggregationDto {
    id: string;
    version: number;
    dateCreated: Date;
    dateChanged: Date;
    boMItemId: string;
    resourceId: string;
    resourceName: string | undefined;
    projectId: string;
    projectOrderNumber: string | undefined;
    projectReference: string | undefined;
    workingStepType: WorkingStepType;
    totalQuantity: QuantityDto;
    lastTimeStamp: Date;
    recordCount: number;
    manualEstimatedTime: number;
    manualEstimatedTimePerPiece: number;
    manualEstimatedTimeAverage: number;
    automaticEstimatedTime: number;
    automaticEstimatedTimePerPiece: number;
    automaticEstimatedTimeAverage: number;
    totalEstimatedTime: number;
    totalEstimatedTimePerPiece: number;
    totalEstimatedTimeAverage: number;
    simulatedTime: number;
    simulatedTimePerPiece: number;
    simulatedTimeAverage: number;
    measuredTime: number;
    measuredTimePerPiece: number;
    measuredTimeAverage: number;
}

export interface ProjectContactPerson {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export interface ProjectCreator {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export interface ProjectDetailsDto {
    projectId: string;
    sellingPartyId: string;
    buyingPartyId: string;
    orderNumber: string | undefined;
    projectReference: string | undefined;
    buyerCompanyName: string | undefined;
    contactPerson: ContactPersonDto;
    postalAddress: AddressDto;
    deliveryAddress: AddressDto;
    vatRatio: QuantityDto;
    deliveryTerms: SimpleDeliveryTermsDto;
    paymentTerms: SimplePaymentTermsDto;
}

export interface ProjectDto {
    isBuyingPartyView?: boolean;
    id?: string;
    projectReference?: string | undefined;
    orderNumber?: string | undefined;
    boM?: BoMDto;
    financial?: ProjectFinancialDto;
    buyingParty?: PartyDto;
    sellingParty?: PartyDto;
    sellingPartyId?: string;
    status?: string | undefined;
    processFlowState?: string | undefined;
    activities?: BoMItemActivityDto[] | undefined;
    attachments?: BoMItemAttachmentDto[] | undefined;
    isManufacturable?: boolean;
    manufacturableStatus?: string | undefined;
    manufacturableResult?: string | undefined;
    isExportedToErp?: boolean;
    exportedToErpStatus?: string | undefined;
    exportedToErpResult?: string | undefined;
    externalUrl?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: CreatorDto;
    salesPerson?: SalesPersonDto;
    contactPerson?: ContactPersonDto;
    comment?: string | undefined;
    nestingQueueCount?: number;
    createdInPortal?: boolean;
    feasibleDeliveryDate?: Date | undefined;
    requestedDeliveryDate?: Date | undefined;
    deliveryEstimation?: DeliveryEstimationDto;
    estimatedDeliveryDate?: Date | undefined;
    estimatedDeliveryDays?: number | undefined;
    quotationDate?: Date | undefined;
    visibleInPortal?: boolean;
    articleSelectionEnabledInPortal?: boolean;
    weight?: QuantityDto;
    validityPeriodDays?: number | undefined;
    quotationExpiresAt?: Date | undefined;
    quotationExpiresIn?: string | undefined;
    version?: number;
    issues?: IssueDto[] | undefined;
    geometrySelectionEnabledInPortal: boolean;
}

export interface ProjectExportTemplateDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ProjectFinancialDto {
    id?: string;
    quantity?: number;
    totalProjectQuantity?: number;
    costPricePerItem?: MoneyDto;
    costPriceOfItems?: MoneyDto;
    salesPricePerItem?: MoneyDto;
    salesPriceOfItems?: MoneyDto;
    targetSalesPricePerItem?: MoneyDto;
    discountRatio?: QuantityDto;
    discountValuePerItem?: MoneyDto;
    discountValueOfItems?: MoneyDto;
    surchargeRatio?: QuantityDto;
    surchargeValuePerItem?: MoneyDto;
    surchargeValueOfItems?: MoneyDto;
    salesPriceInclVatPerItem?: MoneyDto;
    salesPriceInclVatOfItems?: MoneyDto;
    vatRatio?: QuantityDto;
    vatValueOfItems?: MoneyDto;
}

export interface ProjectOperationDto {
    id?: string;
    operationTypeTranslationKey: string | undefined;
    operationTypeTranslationArguments?: (any | undefined)[] | undefined;
    lastUpdatedAt?: Date | undefined;
    createdBy: string | undefined;
    errorMessage?: string | undefined;
    status?: ProjectOperationStatus;
    boMItemId?: string | undefined;
    children?: ProjectOperationDto[] | undefined;
    readonly totalChildrenCount?: number | undefined;
    readonly totalChildrenFailedCount?: number | undefined;
    readonly totalChildrenFinishedCount?: number | undefined;
}

export enum ProjectOperationStatus {
    Queued = "Queued",
    Started = "Started",
    Finished = "Finished",
    Failed = "Failed",
}

export interface ProjectPriceRequestDraftDto {
    suppliers: PriceRequestSupplierDto[] | undefined;
    activities: DraftPriceRequestActivityDto[] | undefined;
}

export interface ProjectPriorityArgs {
    priority?: number;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface ProjectProvideRawMaterialSettingDto {
    workingStepType: WorkingStepType;
    customerProvidesMaterial: boolean | undefined;
}

export interface ProjectSalesPerson {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export interface ProjectSimplifyDto {
    assemblySimplifyDtos: AssemblySimplifyDto[] | undefined;
}

export enum ProjectStateDto {
    NotInitialized = "NotInitialized",
    Defining = "Defining",
    Requested = "Requested",
    Quoting = "Quoting",
    Quoted = "Quoted",
    Negotiating = "Negotiating",
    Ordered = "Ordered",
    Producing = "Producing",
    Produced = "Produced",
    Packaging = "Packaging",
    Packaged = "Packaged",
    Delivering = "Delivering",
    Delivered = "Delivered",
    Cancelled = "Cancelled",
}

export enum ProjectStates {
    NotInitialized = "NotInitialized",
    Defining = "Defining",
    Requested = "Requested",
    Quoting = "Quoting",
    Quoted = "Quoted",
    Negotiating = "Negotiating",
    Ordered = "Ordered",
    Producing = "Producing",
    Produced = "Produced",
    Packaging = "Packaging",
    Packaged = "Packaged",
    Delivering = "Delivering",
    Delivered = "Delivered",
    Cancelled = "Cancelled",
}

export interface ProjectStatusChangedEmailTemplate {
    options?: ProjectStatusChangedEmailTemplateOptions;
    readonly design?: string | undefined;
    readonly html?: string | undefined;
}

export interface ProjectStatusChangedEmailTemplateOptions {
    projectStatus?: string | undefined;
    sendToEmailAsBcc?: string | undefined;
    sendToProjectAuthor?: boolean;
    sendToProjectContactPerson?: boolean;
    sendToSalesAgentAsCC?: boolean;
    sendToMainBuyerPartyContactPersonAsCC?: boolean;
    enabledForPortalOnly?: boolean;
    subject?: string | undefined;
}

export interface ProjectSummaryDto {
    id?: string;
    projectReference: string | undefined;
    orderNumber: string | undefined;
    status: string | undefined;
    numberOfItems?: number;
    lastOperation?: Date;
    priority?: number;
    buyingPartyName: string | undefined;
    sellingPartyName: string | undefined;
    numberOfRows?: number;
    salesPriceOfItems?: MoneyDto;
    buyingPartyId?: string;
    sellingPartyId?: string;
    creator?: ProjectCreator;
    salesPerson?: ProjectSalesPerson;
    removedOn?: Date | undefined;
    contactPerson?: ProjectContactPerson;
    validityPeriodDays?: number | undefined;
    quotationExpiresAt?: Date | undefined;
    quotationExpiresIn?: string | undefined;
    isCreatedInPortal?: boolean;
    isCreatedOn?: Date;
}

export enum ProvideRawMaterialSettingDto {
    NotInitialized = "NotInitialized",
    Provided = "Provided",
    NotProvided = "NotProvided",
}

export interface PurchasePriceDto {
    keywords: { [key: string]: KeywordDto[]; } | undefined;
    purchasingData: PurchasingDataDto;
    code: string | undefined;
    internalDescription: string | undefined;
    externalDescription: string | undefined;
}

export interface PurchasePricesDto {
    isEditable?: boolean;
    purchasePrices?: PurchasePriceDto[] | undefined;
}

export interface PurchasingDataDto {
    grossPriceUpdatedOn: Date;
    grossPrices: PurchasingDataGrossPriceDto[] | undefined;
    preferredSupplier: SellingPartyType;
    grossPriceSource: GrossPriceSource;
}

export interface PurchasingDataGrossPriceDto {
    quantity: QuantityDto;
    price: MoneyPerQuantityDto;
}

export enum PurchasingDimensions {
    NotInitialized = "NotInitialized",
    Length = "Length",
    Width = "Width",
    Height = "Height",
}

export interface QuantityDto {
    value: number;
    unit: string | undefined;
    quantityType: QuantityDtoType;
}

export enum QuantityDtoType {
    Undefined = "Undefined",
    Angle = "Angle",
    Area = "Area",
    Duration = "Duration",
    Length = "Length",
    Mass = "Mass",
    Pieces = "Pieces",
    Ratio = "Ratio",
    Volume = "Volume",
}

export interface QuotationDetailsCurrencyDto {
    code: string | undefined;
    symbol: string | undefined;
    englishName: string | undefined;
    exchangeRateValue: number;
    latestExchangeRateValue: number;
    exchangeRateChanged: boolean;
}

export interface QuotationDetailsDto {
    quotationHeaderText?: string | undefined;
    quotationFooterText?: string | undefined;
    showParts?: boolean;
    showPriceDetails?: boolean;
    languageCode?: string | undefined;
    languageDescription?: string | undefined;
    selectableLanguages?: LanguageDto[] | undefined;
    currencyCode: string | undefined;
    baseCurrencyCode?: string | undefined;
    exchangeRateValue?: number;
    exchangeRateChanged: boolean;
    selectableCurrencies: QuotationDetailsCurrencyDto[] | undefined;
}

export interface QuotationDto {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    ownerPartyId: string;
    projectId: string;
    state: string | undefined;
    orderNumber: string | undefined;
    reference: string | undefined;
    comment: string | undefined;
    sellingPartyName: string | undefined;
    buyingPartyName: string | undefined;
    taxExclusiveAmount: MoneyDto;
    taxInclusiveAmount: MoneyDto;
    allowanceTotalAmount: MoneyDto;
    chargeTotalAmount: MoneyDto;
    quotationDate: Date;
    quotationExpireDate: Date | undefined;
    validityPeriodInDays: number | undefined;
    vatRatio: QuantityDto;
    currencyCode: string | undefined;
    exchangeRate: number;
    deliveryTermsCode: string | undefined;
    paymentTermsCode: string | undefined;
    languageCode: string | undefined;
    lines: QuotationLineDto[] | undefined;
}

export interface QuotationLineDto {
    id: string;
    name: string | undefined;
    comment: string | undefined;
    quantity: number;
    salesPrice: MoneyDto;
}

export interface QuotationWriterSettingsDto {
    showDetails?: boolean;
    showIndividualPartsHeaderData?: boolean;
}

export interface QuotationWriterSettingsRequest {
    showDetails?: boolean;
    showIndividualPartsHeaderData?: boolean;
}

export interface ReSendInviteRequest {
    invitationId?: string;
}

export interface ReSendInviteResponse {
    invitationId?: string;
}

export interface RememberBomItemAsPurchasingPartArgs {
    shallRemember?: boolean;
    projectId?: string;
    itemId?: string;
    articleId: string | undefined;
}

export interface RemnantRequest {
    resourceId: string;
    materialId: string | undefined;
    settings: RemnantSettings;
}

export interface RemnantSettings {
    remnantType: NestingRemnantTypeV2;
    minimumWidth: QuantityDto;
    minimumArea: QuantityDto;
}

export interface RemoveDashboardRequest {
    dashboardType?: DashboardType;
}

export interface RepairProjectAnalysisStatusesRequest {
    projectId?: string;
}

export interface RepairProjectAnalysisStatusesResponse {
    success?: boolean;
}

export interface RequestForQuotationDto {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    ownerPartyId: string;
    fileName: string | undefined;
    status: string | undefined;
    buyerRelationId: string | undefined;
    parsed: boolean;
    parseErrorMessage: string | undefined;
    parseErrorStackTrace: string | undefined;
    projectId: string | undefined;
    createProjectErrorMessage: string | undefined;
    createProjectErrorStackTrace: string | undefined;
}

export interface ResetPasswordEmailTemplate {
    options?: ResetPasswordEmailTemplateOptions;
    readonly design?: string | undefined;
    readonly html?: string | undefined;
}

export interface ResetPasswordEmailTemplateOptions {
    subject?: string | undefined;
}

export enum ResourceActivityTypeDto {
    NotInitialized = "NotInitialized",
    Additional = "Additional",
    Required = "Required",
    Optional = "Optional",
}

export interface ResourceDto {
    id: string | undefined;
    name: string | undefined;
    priority: number;
    activities: ActivityDto[] | undefined;
    isOutsourced: boolean;
    hasNestableActivities: boolean;
    nestingParams: NestingParamsDto;
    workingStepType: WorkingStepType;
    hasCapableEstimator: boolean;
}

export enum ResourceMatchType {
    NotInitialized = "NotInitialized",
    NoCapableResources = "NoCapableResources",
    OneCapableResource = "OneCapableResource",
    BestOfMultipleCapableResources = "BestOfMultipleCapableResources",
    OneOfMultipleCapableResources = "OneOfMultipleCapableResources",
}

export interface ResourceSummaryDto {
    id: string | undefined;
    name: string | undefined;
    workingStepType: WorkingStepType;
    isOutsourced: boolean;
}

export interface RestoreRemovedProjectArgs {
    projectIds: string[] | undefined;
}

export interface RestoreRemovedProjectsResponse {
    isSuccess?: boolean;
}

export interface RevokeAccessRequest {
    buyingPartyId?: string;
    relationId?: string;
}

export interface RevokeInviteRequest {
    inviteId?: string;
}

export interface RhTenantInfo {
    id?: string | undefined;
    identifier?: string | undefined;
    name?: string | undefined;
    partyId?: string;
}

export interface RoutingHeader {
    key?: string | undefined;
    routingSteps?: RoutingStep[] | undefined;
    bomItems?: BoMItemReference[] | undefined;
}

export interface RoutingStep {
    resourceId?: string;
    resourceName?: string | undefined;
    workingStepType?: WorkingStepType;
}

export interface RowDto {
    id?: string;
    partTypeId?: string;
    parentId?: string;
    rowNumber: number;
    name?: string | undefined;
    rawMaterialSummary?: MaterialSummaryDto;
    activities?: BoMItemActivityDto[] | undefined;
    thumbnail3d?: string | undefined;
    thumbnail2d?: string | undefined;
    has2dThumbnail?: boolean;
    threeDModelPath?: string | undefined;
    twoDModelPath?: string | undefined;
    financial?: FinancialDto;
    canChangeQuantity?: boolean;
    issues?: IssueDto[] | undefined;
    selectableNestingDirections?: NestingDirection[] | undefined;
    selectedNestingDirection?: NestingDirection;
    isPurchasingBomItem?: boolean;
    isRememberedPurchasingBoMItem?: boolean;
    attachments?: BoMItemAttachmentDto[] | undefined;
    originalFileName?: string | undefined;
    canCheckManufacturability: boolean;
    isManufacturable?: boolean;
    manufacturableStatus?: string | undefined;
    manufacturableResult?: string | undefined;
    isExportedToErp?: boolean;
    exportedToErpStatus?: string | undefined;
    exportedToErpResult?: string | undefined;
    externalUrl?: string | undefined;
    canManualEditCostPrice?: boolean;
    comment?: string | undefined;
    canBeEdit?: boolean;
    precisions?: PrecisionsDto;
    showPrecisions?: boolean;
    drawingNumber?: string | undefined;
    revision?: string | undefined;
    dimensionsSummary?: DimensionSummaryDto;
    geometryType?: GeometryTypeDto;
    recognizedGeometryTypes?: GeometryTypeDto[] | undefined;
    isRawMaterialProvided: boolean | undefined;
    lengthUnitAbbreviation: string | undefined;
    buyingPartyArticleNumber?: string | undefined;
    sellingPartyArticleNumber?: string | undefined;
    animalScale?: AnimalScale;
    engineeringDrawingThumbnail?: string | undefined;
}

export interface RuleEditorClientSettings {
    editorData: string | undefined;
    sourceData: string | undefined;
}

export interface SalesPerson {
    userId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    picture: string | undefined;
}

export interface SalesPersonDto {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    picture?: string | undefined;
}

export interface ScaledDurationAndPercentageDto {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface SearchPartyDto {
    partyId: string;
    relationId: string;
    address: AddressDto;
    deliveryAddress: AddressDto;
    legalName: string | undefined;
    contactPerson: ContactPersonDto;
    vatRatio: QuantityDto;
    deliveryTerms: SimpleDeliveryTermsDto;
    paymentTerms: SimplePaymentTermsDto;
}

export interface SegmentedDurationAndPercentageModel {
    segmentId: string;
    scaledDiscounts: DurationAndPercentageModel[] | undefined;
}

export interface SegmentedMaterialScaledDiscountDto {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface SegmentedMaterialScaledDiscountsDto {
    material: string | undefined;
    segmentId: string;
    segmentName: string | undefined;
    scaledDiscounts?: SegmentedMaterialScaledDiscountDto[] | undefined;
}

export interface SegmentedResourceScaledDiscountsDto {
    resourceId: string;
    segmentId: string;
    segmentName: string | undefined;
    scaledDiscounts?: SegmentedWorkingStepScaledDiscountDto[] | undefined;
}

export interface SegmentedWorkingStepScaledDiscountDto {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface SegmentedWorkingStepScaledDiscountsDto {
    workingStepType: WorkingStepType;
    segmentId: string;
    segmentName: string | undefined;
    scaledDiscounts?: SegmentedWorkingStepScaledDiscountDto[] | undefined;
}

export interface SelectBoMItemUpperSideRequest {
    sideId: number;
}

export interface SelectableCustomerDto {
    partyId: string;
    companyName: string | undefined;
    address: string | undefined;
    email: string | undefined;
}

export interface SelectablePartyCurrencyDto {
    code: string | undefined;
    symbol: string | undefined;
    englishName: string | undefined;
    exchangeRate: number | undefined;
}

export interface SelectedPartyCurrencyDto {
    code: string | undefined;
    exchangeRateValue: number;
    newExchangeRateValue: number | undefined;
    exchangeRateChanged: boolean;
}

export interface SelectedResourceDto {
    id?: string;
    name?: string | undefined;
    matchType?: ResourceMatchType;
    readonly matchDescription?: string | undefined;
}

export interface SellingPartyDto {
    id: string;
    legalName: string | undefined;
}

export enum SellingPartyType {
    NotInitialized = "NotInitialized",
    MCB = "MCB",
}

export interface SendActivationEmailRequest {
    redirectUrl: string | undefined;
}

export interface SendActivationEmailResponse {
}

export interface SendInviteRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    buyerPartyId?: string;
    relationId?: string;
}

export interface SendInviteResponse {
    invitationId?: string;
}

export interface SetActivityArticleHandlerRequest {
    bomItemIdsAndActivities?: BomItemIdAndActivity[] | undefined;
    articleId: string | undefined;
}

export interface SetActivityArticleHandlerResponse {
}

export interface SetActivityAsOutsourcedRequest {
    boMItemId?: string;
    boMItemActivityId?: string;
}

export interface SetActivityKeywordsHandlerRequest {
    bomItemIdsAndActivities?: BomItemIdAndActivityId[] | undefined;
    keywords?: string[] | undefined;
}

export interface SetBoMItemAsPurchasingPartRequest {
    costPricePerItem?: MoneyDto;
    surchargePercentage?: number | undefined;
    discountPercentage?: number | undefined;
    articleId?: string | undefined;
    keywords?: string[] | undefined;
}

export interface SetBoMItemDrawingNumberRequest {
    boMItemId?: string;
    drawingNumber?: string | undefined;
}

export interface SetBoMItemRevisionRequest {
    boMItemId?: string;
    revision?: string | undefined;
}

export interface SetCurrencyRequest {
    currencyCode: string | undefined;
}

export interface SetCustomerPortalWorkingStepRequest {
    workingStepType?: WorkingStepType;
    availableInPortal?: boolean;
    hiddenInPortal?: boolean;
    notRemovableInPortal?: boolean;
}

export interface SetCustomerPortalWorkingStepsRequest {
    availableWorkingStepTypes?: WorkingStepType[] | undefined;
    hiddenWorkingStepTypes?: WorkingStepType[] | undefined;
    notRemovableWorkingStepTypes?: WorkingStepType[] | undefined;
}

export interface SetEmailAddressRequest {
    name: string | undefined;
    emailAddress: string | undefined;
}

export interface SetEstimatedDeliveryDateRequest {
    estimatedDeliveryDate?: Date;
}

export interface SetEstimatedDeliveryDaysRequest {
    estimatedDeliveryDays?: number;
}

export interface SetFakeCadEngineResultRequest {
    priceRequestRowId?: string;
}

export interface SetFeasibleDeliveryDateRequest {
    feasibleDeliveryDate?: Date;
}

export interface SetImnooIntegrationSettingsRequest {
    usePartNameAsArticleNumber?: boolean;
    useBuyingPartyNamePrefixInArticleName?: boolean;
    autofillArticleWithDrawingData?: boolean;
    useBuyingPartyNameInDrawingIndex?: boolean;
}

export interface SetImnooMaterialMappingsRequest {
    mappings?: ImnooMaterialMappingModel[] | undefined;
}

export interface SetImnooResourceMappingsRequest {
    mappings?: ImnooResourceMappingModel[] | undefined;
}

export interface SetIncomingPriceRequestRowPriceRequest {
    priceRequestRowId?: string;
    price?: number;
}

export interface SetKeywordsOrArticleToPartsArgs {
    rowIds?: string[] | undefined;
    articleId?: string | undefined;
    keywords?: string[] | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface SetMaterialCostPriceArgs {
    costPrice: MoneyDto;
    priceScope?: PriceScope;
}

export interface SetNestingDirectionArgs {
    nestingDirection?: NestingDirection;
}

export interface SetNestingEngineRequest {
    nestingEngine: string | undefined;
}

export interface SetPartyCurrencyDto {
    code: string | undefined;
    exchangeRateValue: number;
}

export interface SetPartyCurrencyRequest {
    currencies: SetPartyCurrencyDto[] | undefined;
}

export interface SetPartyMachiningSettingsRequestBody {
    roundBarMinimumOffset: QuantityDto;
    roundBarMaximumOffset: QuantityDto;
    squareBarMinimumOffset: QuantityDto;
    squareBarMaximumOffset: QuantityDto;
    machiningPartLenghtPercentage: QuantityDto;
    diameterMargin: QuantityDto;
    lengthMargin: QuantityDto;
    widthMargin: QuantityDto;
    heightMargin: QuantityDto;
    sawingRoundBarMinimumOffset: QuantityDto;
    sawingRoundBarMaximumOffset: QuantityDto;
    sawingSquareBarMinimumOffset: QuantityDto;
    sawingSquareBarMaximumOffset: QuantityDto;
}

export interface SetPrecisionsArgs {
    bomItemIds?: string[] | undefined;
    geometricTolerance?: GeometricTolerance;
    surfaceRoughness?: SurfaceRoughness;
    linearAndAngleTolerance?: LinearAndAngleTolerance;
}

export interface SetRecognitionResultSelectorSettingsRequest {
    categories?: GeometryTypeCategoryDto[] | undefined;
}

export interface SetRequestedDeliveryDateRequest {
    requestedDeliveryDate?: Date;
}

export interface SetResourceDiscountRequest {
    discountRatio?: QuantityDto;
    discountValue?: MoneyDto;
}

export interface SetResourcePriorityRequest {
    priority: number;
}

export interface SetResourcePriorityResponse {
    resource: ResourceDto;
}

export interface SetResourceSurchargeRequest {
    surchargeRatio?: QuantityDto;
    surchargeValue?: MoneyDto;
}

export interface SetSelectedResourceArgs {
    boMItemIds?: string[] | undefined;
    resourceId?: string;
    workingStepType?: WorkingStepType;
}

export interface SetUpperSideSelectionSettingsRequest {
    color: string | undefined;
}

export interface SetValidityPeriodDaysRequest {
    validityPeriodDays?: number;
}

export enum ShareRatioBy {
    NotInitialized = "NotInitialized",
    CostPrice = "CostPrice",
    Weight = "Weight",
    Volume = "Volume",
    Area2d = "Area2d",
    NumberOfPartsUnique = "NumberOfPartsUnique",
    NumberOfPartsTotalProjectAmount = "NumberOfPartsTotalProjectAmount",
    NumberOfUniqueMaterialsDividedOverParts = "NumberOfUniqueMaterialsDividedOverParts",
}

export interface SimpleDeliveryTermsDto {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface SimplePaymentTermsDto {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface SolveIssuesArgs {
    bomItemIds?: string[] | undefined;
    issueCodes?: IssueCode[] | undefined;
}

export interface StandardDto {
    name: string | undefined;
    keywords: StandardKeywordDto[] | undefined;
}

export interface StandardKeywordDto {
    name: string | undefined;
    isSelected: boolean;
    relatedStandard: string | undefined;
}

export enum StepExtensionSettingEnumDto {
    Default = "Default",
    UseOriginalFileExtension = "UseOriginalFileExtension",
    Stp = "Stp",
    Step = "Step",
}

export interface SupplierActivityDto {
    id: string;
    supplierId: string;
    activity: WorkingStepType;
}

export interface SupplierArticleDto {
    id: string;
    supplierId: string;
    articleCode: string | undefined;
    supplierArticleCode: string | undefined;
    externalKey: string | undefined;
}

export interface SupplierArticleImportErrorDto {
    rowNumber: number;
    errors: string[] | undefined;
    warnings: string[] | undefined;
}

export interface SupplierArticlesImportJobDto {
    id: string;
    startTime: Date;
    finishedTime: Date | undefined;
    status: string | undefined;
    total: number;
    inserted: number;
    updated: number;
    skipped: number;
    deleted: number;
    errors: SupplierArticleImportErrorDto[] | undefined;
}

export interface SupplierImportErrorDto {
    rowNumber: number;
    errors: string[] | undefined;
    warnings: string[] | undefined;
}

export interface SupplierManagementDto {
    id: string;
    code: string | undefined;
    name: string | undefined;
    externalKey: string | undefined;
    partyId: string | undefined;
}

export interface SupplierManagementImportJobDto {
    id: string;
    startTime: Date;
    finishedTime: Date | undefined;
    status: string | undefined;
    total: number;
    inserted: number;
    updated: number;
    skipped: number;
    deleted: number;
    errors: SupplierImportErrorDto[] | undefined;
}

export enum SurfaceRoughness {
    NotApplicable = "NotApplicable",
    Fine = "Fine",
    Medium = "Medium",
    Coarse = "Coarse",
}

export interface SvgShape {
    readonly shape?: string | undefined;
}

export interface SwitchPartTypeGeometryTypeRequest {
    geometryType?: GeometryType;
}

export enum TemplateType {
    NotInitialized = "NotInitialized",
    Quotation = "Quotation",
    Order = "Order",
    Invoice = "Invoice",
    BillOfMaterials = "BillOfMaterials",
    BillOfLabor = "BillOfLabor",
}

export interface TemplateTypeDto {
    type: TemplateType;
    languageCode: string | undefined;
    languageDescription: string | undefined;
}

export interface TimeRegistrationImportErrorDto {
    rowNumber?: number;
    errors?: string[] | undefined;
}

export interface TimeRegistrationImportJobDto {
    id?: string;
    startTime?: Date;
    finishedTime?: Date | undefined;
    status?: TimeRegistrationImportJobStatusDto;
    total?: number;
    inserted?: number;
    updated?: number;
    skipped?: number;
    deleted?: number;
    errors: TimeRegistrationImportErrorDto[] | undefined;
}

export enum TimeRegistrationImportJobStatusDto {
    New = "New",
    Running = "Running",
    Succeed = "Succeed",
    ContainsErrors = "ContainsErrors",
}

export interface ToleranceInfo {
    name?: string | undefined;
    value?: string | undefined;
    selectableValues?: string[] | undefined;
}

export interface TranslatedFieldDto {
    defaultValue: string | undefined;
    translations: TranslatedValueDto[] | undefined;
}

export interface TranslatedValueDto {
    languageCode: string | undefined;
    value: string | undefined;
}

export interface TwoDimensionNestingSizeDto {
    length: QuantityDto;
    height: QuantityDto;
}

export interface UIError {
    message?: string | undefined;
}

export interface UnassignPartyRoleRequest {
    userId: string | undefined;
    role: string | undefined;
    partyId: string;
}

export interface UnassignSystemRoleRequest {
    userId: string | undefined;
    role: string | undefined;
}

export interface UpdateActivityArgs {
    activity: ActivityDto;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface UpdateAgentIntegrationArgs {
    integration: AgentIntegrationDto;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface UpdateAgentRequest {
    agent: AgentDto;
}

export interface UpdateAllowedImportDocumentTypesRequest {
    partyId?: string;
    allowedImportDocumentTypes?: ImportDocumentType[] | undefined;
}

export interface UpdateAllowedImportDocumentTypesResponse {
    allowedImportDocumentTypes?: ImportDocumentType[] | undefined;
}

export interface UpdateArticleDescription {
    articleCode?: string | undefined;
    internalDescription?: string | undefined;
}

export interface UpdateArticleDescriptionResultDto {
    articleCode: string | undefined;
    message: string | undefined;
    exception: any | undefined;
    state: UpdateArticleDescriptionResultStateDto;
}

export enum UpdateArticleDescriptionResultStateDto {
    Succeed = "Succeed",
    Skipped = "Skipped",
    Failed = "Failed",
}

export interface UpdateArticleDescriptionsRequest {
    models?: UpdateArticleDescription[] | undefined;
}

export interface UpdateArticleDescriptionsResponse {
    updateArticleDescriptionsResult?: UpdateArticleDescriptionsResultDto;
}

export interface UpdateArticleDescriptionsResultDto {
    totalCount: number;
    succeedCount: number;
    skippedCount: number;
    failedCount: number;
    results: UpdateArticleDescriptionResultDto[] | undefined;
}

export interface UpdateBeamNotificationsRequest {
    shallBeamNotifications?: boolean;
}

export interface UpdateBomItemActivityCommentRequest {
    boMItemActivityId?: string;
    comment?: string | undefined;
}

export interface UpdateBomItemCheckListItemArgs {
    done?: boolean | undefined;
    customDescription?: string | undefined;
}

export interface UpdateBomItemCommentRequest {
    comment?: string | undefined;
}

export interface UpdateBusinessRulesSettingsRequest {
    areaUnit: AreaUnit;
    lengthUnit: LengthUnit;
    volumeUnit: VolumeUnit;
    massUnit: MassUnit;
}

export interface UpdateDeliveryTermsRequest {
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface UpdateDeliveryTermsResponse {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface UpdateMaterialScaledDiscountModel {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateMaterialScaledDiscountsAndSurchargesRequest {
    material: string | undefined;
    scaledDiscounts?: UpdateMaterialScaledDiscountModel[] | undefined;
    segmentedScaledDiscounts?: UpdateSegmentedMaterialScaledDiscountsModel[] | undefined;
    scaledSurcharges?: UpdateMaterialScaledSurchargeModel[] | undefined;
}

export interface UpdateMaterialScaledSurchargeModel {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateNestingSettingsRequest {
    selectedLengthDimensions: QuantityDto[] | undefined;
    selectedSheetDimensions: TwoDimensionNestingSizeDto[] | undefined;
}

export interface UpdatePartyCalculationSettingsRequest {
    discountCalculationMethod?: DiscountCalculationMethodDto;
}

export interface UpdatePartyDefaultLengthSettingsRequest {
    selectedLengthUnit: string | undefined;
}

export interface UpdatePartyProvideRawMaterialSettingsRequest {
    selected: WorkingStepType[] | undefined;
}

export interface UpdatePartyRequest {
    partyId: string;
    name: string | undefined;
    coCKey: string | undefined;
    hasSubscription: boolean;
    hasSelfServicePortal: boolean;
    hasSupportChat: boolean;
    hasSelfServicePortalSupportChat: boolean;
    modules?: AppModule[] | undefined;
    dateFormat: string | undefined;
}

export interface UpdatePartyStepSettingsRequest {
    stepExtensionSetting?: StepExtensionSettingEnumDto;
}

export interface UpdatePartyUserRequest {
    userId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export interface UpdatePartyUserRoleRequest {
    userId: string | undefined;
    role: string | undefined;
}

export interface UpdatePaymentTermsRequest {
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface UpdatePaymentTermsResponse {
    id: string;
    dateCreated: Date;
    dateChanged: Date;
    code: string | undefined;
    description: string | undefined;
    quotationDescription: TranslatedFieldDto;
    enabled: boolean;
}

export interface UpdatePortalUrlRequest {
    url: string | undefined;
}

export interface UpdateProjectCancelSettingsRequest {
    retentionDaysWhenDefining?: number | undefined;
    retentionDaysWhenRequested?: number | undefined;
    retentionDaysWhenQuoting?: number | undefined;
    retentionDaysWhenQuoted?: number | undefined;
}

export interface UpdateProjectDetailsRequest {
    orderNumber?: string | undefined;
    projectReference?: string | undefined;
    vatRatio?: QuantityDto;
    buyingPartyName?: string | undefined;
    contactPerson?: ContactPersonDto;
    postalAddress?: AddressDto;
    deliveryAddress?: AddressDto;
    deliveryTermsCode?: string | undefined;
    paymentTermsCode?: string | undefined;
}

export interface UpdateProjectProvideRawMaterialSettingsRequest {
    workingSteps: ProjectProvideRawMaterialSettingDto[] | undefined;
}

export interface UpdateRequestForQuotationRequest {
    buyerRelationId: string | undefined;
}

export interface UpdateResourceArgs {
    name: string | undefined;
    isOutsourced: boolean;
    nestingParamsDto: NestingParamsDto;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface UpdateResourceDiscountAndSurchargeRequest {
    scaledDiscounts: DurationAndPercentageModel[] | undefined;
    segmentedScaledDiscounts: SegmentedDurationAndPercentageModel[] | undefined;
    scaledSurcharges: DurationAndPercentageModel[] | undefined;
}

export interface UpdateResourceDiscountUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UpdateResourceSurchargeUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UpdateSegmentResourceDiscountUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UpdateSegmentWorkingStepDiscountUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UpdateSegmentedMaterialScaledDiscountModel {
    quantity: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateSegmentedMaterialScaledDiscountsModel {
    segmentId?: string;
    scaledDiscounts?: UpdateSegmentedMaterialScaledDiscountModel[] | undefined;
}

export interface UpdateSegmentedWorkingStepScaledDiscountModel {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateSegmentedWorkingStepScaledDiscountsModel {
    segmentId?: string;
    scaledDiscounts?: UpdateSegmentedWorkingStepScaledDiscountModel[] | undefined;
}

export interface UpdateSupplierPartyIdRequest {
    supplierId?: string;
    supplierPartyId?: string;
}

export interface UpdateTemplateRequest {
    id?: string;
    name: string | undefined;
    description: string | undefined;
    file?: string | undefined;
}

export interface UpdateUserRequest {
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export interface UpdateWorkingStepDiscountUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UpdateWorkingStepProductionOrderResponse {
    workingSteps?: WorkingStepType[] | undefined;
}

export interface UpdateWorkingStepScaledDiscountModel {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateWorkingStepScaledDiscountsAndSurchargesRequest {
    scaledDiscounts?: UpdateWorkingStepScaledDiscountModel[] | undefined;
    segmentedScaledDiscounts?: UpdateSegmentedWorkingStepScaledDiscountsModel[] | undefined;
    scaledSurcharges?: UpdateWorkingStepScaledSurchargeModel[] | undefined;
}

export interface UpdateWorkingStepScaledSurchargeModel {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface UpdateWorkingStepSurchargeUnitOfMeasureRequest {
    abbreviation: string | undefined;
}

export interface UploadRequestForQuotationResponse {
    id: string;
}

export interface UploadSupplierArticlesResponse {
    jobId: string;
}

export interface UserDto {
    picture: string | undefined;
    email: string | undefined;
    email_verified: boolean;
    company: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    readonly fullName?: string | undefined;
    partiesDto: PartySummaryDto[] | undefined;
    availablePortals: PortalInfo[] | undefined;
    intercomHash: string | undefined;
}

export interface ValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface VerifyDomainAuthenticationResponse {
    active?: EmailSenderDto;
    pending?: EmailSenderDto;
}

export enum VolumeUnit {
    Undefined = "Undefined",
    AcreFoot = "AcreFoot",
    AuTablespoon = "AuTablespoon",
    BoardFoot = "BoardFoot",
    Centiliter = "Centiliter",
    CubicCentimeter = "CubicCentimeter",
    CubicDecimeter = "CubicDecimeter",
    CubicFoot = "CubicFoot",
    CubicHectometer = "CubicHectometer",
    CubicInch = "CubicInch",
    CubicKilometer = "CubicKilometer",
    CubicMeter = "CubicMeter",
    CubicMicrometer = "CubicMicrometer",
    CubicMile = "CubicMile",
    CubicMillimeter = "CubicMillimeter",
    CubicYard = "CubicYard",
    DecausGallon = "DecausGallon",
    Deciliter = "Deciliter",
    DeciusGallon = "DeciusGallon",
    HectocubicFoot = "HectocubicFoot",
    HectocubicMeter = "HectocubicMeter",
    Hectoliter = "Hectoliter",
    HectousGallon = "HectousGallon",
    ImperialBeerBarrel = "ImperialBeerBarrel",
    ImperialGallon = "ImperialGallon",
    ImperialOunce = "ImperialOunce",
    ImperialPint = "ImperialPint",
    KilocubicFoot = "KilocubicFoot",
    KilocubicMeter = "KilocubicMeter",
    KiloimperialGallon = "KiloimperialGallon",
    Kiloliter = "Kiloliter",
    KilousGallon = "KilousGallon",
    Liter = "Liter",
    MegacubicFoot = "MegacubicFoot",
    MegaimperialGallon = "MegaimperialGallon",
    Megaliter = "Megaliter",
    MegausGallon = "MegausGallon",
    MetricCup = "MetricCup",
    MetricTeaspoon = "MetricTeaspoon",
    Microliter = "Microliter",
    Milliliter = "Milliliter",
    OilBarrel = "OilBarrel",
    UkTablespoon = "UkTablespoon",
    UsBeerBarrel = "UsBeerBarrel",
    UsCustomaryCup = "UsCustomaryCup",
    UsGallon = "UsGallon",
    UsLegalCup = "UsLegalCup",
    UsOunce = "UsOunce",
    UsPint = "UsPint",
    UsQuart = "UsQuart",
    UsTablespoon = "UsTablespoon",
    UsTeaspoon = "UsTeaspoon",
}

export interface WebEvent {
    eventType: EventTypes;
    eventData: any | undefined;
    success: boolean;
}

export interface WorkingStepChangeProductionOrderArgs {
    bomItemIds?: string[] | undefined;
    moveAfter?: WorkingStepType;
}

export interface WorkingStepDto {
    primaryWorkingStep?: WorkingStepType;
    secondaryWorkingStep?: WorkingStepType;
    resource?: SelectedResourceDto;
    key?: string | undefined;
    isPrimaryWorkingStep?: boolean;
    usesRawMaterial?: boolean;
    notRemovable?: boolean;
    keywords?: { [key: string]: KeywordDto[]; } | undefined;
}

export interface WorkingStepRouteDto {
    id: string;
    name: string | undefined;
    steps?: WorkingStepType[] | undefined;
}

export interface WorkingStepScaledDiscountDto {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export interface WorkingStepScaledDiscountsAndSurchargesDto {
    workingStep?: WorkingStepType;
    scaledDiscounts?: WorkingStepScaledDiscountDto[] | undefined;
    segmentedDiscounts?: SegmentedWorkingStepScaledDiscountsDto[] | undefined;
    scaledSurcharges?: WorkingStepScaledSurchargeDto[] | undefined;
}

export interface WorkingStepScaledSurchargeDto {
    duration: QuantityDto;
    percentage: QuantityDto;
}

export enum WorkingStepType {
    NotInitialized = "NotInitialized",
    SheetCutting = "SheetCutting",
    Sawing = "Sawing",
    SheetBending = "SheetBending",
    CounterSinking = "CounterSinking",
    Milling = "Milling",
    TubeOrProfileCutting = "TubeOrProfileCutting",
    Turning = "Turning",
    Purchasing = "Purchasing",
    Engraving = "Engraving",
    ThreadTapping = "ThreadTapping",
    Anodising = "Anodising",
    Assembling = "Assembling",
    BoltPressing = "BoltPressing",
    Deburring = "Deburring",
    Drilling = "Drilling",
    EdgeMilling = "EdgeMilling",
    EdgeTrimming = "EdgeTrimming",
    LevelTensioning = "LevelTensioning",
    NutPressing = "NutPressing",
    PicklingPassivating = "PicklingPassivating",
    Polishing = "Polishing",
    PowderCoating = "PowderCoating",
    Punching = "Punching",
    Rolling = "Rolling",
    StudWelding = "StudWelding",
    TubeProfileOrBarBending = "TubeProfileOrBarBending",
    Welding = "Welding",
    ZincPlating = "ZincPlating",
    Designing = "Designing",
    Loading = "Loading",
    Unloading = "Unloading",
    SheetShearing = "SheetShearing",
    Setup = "Setup",
    Certifying = "Certifying",
    Shipping = "Shipping",
    Programming = "Programming",
    OrderPicking = "OrderPicking",
    Packaging = "Packaging",
    BeadBlasting = "BeadBlasting",
    SandBlasting = "SandBlasting",
    SteelGridBlasting = "SteelGridBlasting",
    WetBlasting = "WetBlasting",
    VacuumBlasting = "VacuumBlasting",
    CentrifugalBlasting = "CentrifugalBlasting",
    SodaBlasting = "SodaBlasting",
    BristleBlasting = "BristleBlasting",
    DryIceBlasting = "DryIceBlasting",
    PencilBlasting = "PencilBlasting",
    WeldGrinding = "WeldGrinding",
    RobotWelding = "RobotWelding",
    RobotStudWelding = "RobotStudWelding",
    Nitriding = "Nitriding",
    DieSinking = "DieSinking",
    WireErosion = "WireErosion",
    Hemming = "Hemming",
    VibratoryDeburring = "VibratoryDeburring",
    Foiling = "Foiling",
    Cleaning = "Cleaning",
    QualityControlling = "QualityControlling",
    ElectrolyticPolishing = "ElectrolyticPolishing",
    CathodicDipCoating = "CathodicDipCoating",
    ElectrophoreticDipCoating = "ElectrophoreticDipCoating",
    FlowDrilling = "FlowDrilling",
    HoleProtectioning = "HoleProtectioning",
    Operating = "Operating",
    Researching = "Researching",
    Sawing3d = "Sawing3d",
    NickelPlating = "NickelPlating",
    ZincPlatingRack = "ZincPlatingRack",
    ZincPlatingBarrel = "ZincPlatingBarrel",
    WetPainting = "WetPainting",
    MicroJointRemoval = "MicroJointRemoval",
    Reaming = "Reaming",
    Riveting = "Riveting",
    OrbitalSanding = "OrbitalSanding",
    RedLeadPriming = "RedLeadPriming",
    Tooling = "Tooling",
    WeldingFixture = "WeldingFixture",
    Prototyping = "Prototyping",
    Priming = "Priming",
}

export interface WorkingStepsArgs {
    itemIds?: string[] | undefined;
    formData?: any | undefined;
    workingStepDto: WorkingStepDto;
    comment?: string | undefined;
    readonly isValid?: boolean;
    readonly validationMessage?: string | undefined;
    readonly validationDictionary?: { [key: string]: string; } | undefined;
}

export interface WorkingStepsDto {
    selectedWorkingSteps?: WorkingStepDto[] | undefined;
    availableWorkingSteps?: WorkingStepDto[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}